var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcAll8(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 1024,
    "node-id": 1,
    sillyvg: "true",
    "template-height": 1024,
    "template-width": 1024,
    viewBox: "0 0 1024 1024",
    width: 1024,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    "node-id": 170
  }, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path",
    "node-id": 5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 313.20 326.50 L 805.10 326.50 L 805.10 789.60 L 313.20 789.60 Z",
    fill: "#000000",
    fillRule: "nonzero",
    "node-id": 173,
    stroke: "none",
    "target-height": 463.09998,
    "target-width": 491.89996,
    "target-x": 313.2,
    "target-y": 326.5
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "node-id": 543
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 656.10 788.60 L 607.70 768.70 L 586.20 760.40 L 567.30 753.70 L 543.40 746.10 L 521.90 740.80 L 511.70 738.80 L 501.80 737.40 L 492.00 736.50 L 482.20 736.00 L 472.50 736.00 L 462.80 736.50 L 452.70 737.50 L 442.40 738.90 L 421.20 743.10 L 409.60 746.00 L 391.90 750.90 L 371.80 757.10 L 310.40 777.40 L 294.80 782.00 L 280.00 785.90 L 265.90 789.20 L 252.60 791.80 L 238.50 794.00 L 225.20 795.60 L 212.80 796.60 L 201.00 797.10 L 189.90 797.10 L 178.40 796.50 L 167.60 795.40 L 157.60 793.90 L 148.20 792.00 L 139.50 789.70 L 130.60 786.70 L 122.40 783.30 L 114.90 779.60 L 108.00 775.60 L 101.70 771.30 L 95.60 766.30 L 90.10 761.10 L 85.20 755.60 L 80.80 749.70 L 77.00 743.60 L 73.70 737.10 L 70.90 730.40 L 68.70 723.40 L 67.00 716.10 L 65.90 708.40 L 65.50 702.20 L 65.50 696.50 L 66.00 691.00 L 66.90 685.80 L 68.10 680.80 L 70.20 674.80 L 72.90 669.00 L 76.20 663.40 L 79.90 658.10 L 84.10 653.10 L 88.80 648.30 L 94.00 643.70 L 99.60 639.20 L 107.50 633.60 L 116.10 628.20 L 125.40 623.00 L 144.90 613.40 L 171.40 602.00 L 221.10 581.60 L 237.40 574.40 L 253.10 566.90 L 263.40 561.50 L 273.10 555.90 L 282.30 550.00 L 295.30 540.40 L 306.80 530.10 L 312.00 524.50 L 316.70 518.60 L 321.00 512.50 L 324.80 506.10 L 327.40 500.80 L 329.70 495.20 L 331.60 489.40 L 333.20 483.30 L 334.50 477.00 L 335.20 470.70 L 335.60 464.10 L 335.60 457.10 L 335.10 449.70 L 332.70 431.30 L 331.80 421.30 L 331.50 411.80 L 331.50 402.70 L 332.10 394.00 L 333.00 385.70 L 334.40 377.10 L 336.30 369.00 L 338.50 361.20 L 341.10 353.70 L 344.10 346.50 L 347.50 339.70 L 352.10 331.60 L 357.10 324.00 L 362.70 316.70 L 368.70 309.70 L 375.30 303.20 L 382.20 297.00 L 389.50 291.20 L 397.30 285.60 L 405.60 280.40 L 414.30 275.40 L 423.10 271.00 L 432.30 266.80 L 441.90 262.80 L 451.90 259.20 L 462.30 255.80 L 475.30 252.20 L 488.80 248.90 L 502.70 246.10 L 517.20 243.70 L 531.60 241.70 L 545.30 240.40 L 558.40 239.70 L 570.90 239.50 L 581.20 239.80 L 590.90 240.50 L 600.20 241.50 L 609.00 243.00 L 617.40 244.80 L 625.80 247.10 L 633.80 249.80 L 641.30 253.00 L 648.30 256.50 L 654.80 260.40 L 660.10 264.10 L 665.10 268.10 L 669.70 272.40 L 674.00 277.00 L 678.00 282.00 L 681.70 287.30 L 684.90 292.70 L 687.90 298.60 L 690.50 304.80 L 692.80 311.50 L 694.80 318.60 L 696.40 326.30 L 697.50 333.60 L 698.20 341.40 L 698.60 349.80 L 698.60 358.70 L 698.10 368.20 L 697.20 378.30 L 695.40 392.10 L 689.70 428.60 L 688.90 436.10 L 688.50 449.80 L 689.60 459.50 L 692.10 468.60 L 694.00 472.80 L 696.40 477.00 L 699.40 481.10 L 702.90 485.10 L 706.80 488.70 L 711.40 492.30 L 716.90 495.90 L 723.30 499.50 L 729.70 502.60 L 737.10 505.70 L 745.70 508.80 L 755.60 512.00 L 777.10 517.50 L 788.60 519.90 L 806.10 523.10 L 860.70 532.10 L 879.00 535.40 L 896.80 539.30 L 908.60 542.30 L 920.10 545.60 L 931.10 549.30 L 947.20 555.90 L 962.20 563.60 L 969.30 568.10 L 976.00 572.90 L 982.40 578.10 L 988.50 583.70 L 993.00 588.50 L 997.30 593.60 L 1001.30 599.10 L 1005.10 604.90 L 1008.60 611.10 L 1011.70 617.30 L 1014.50 624.00 L 1017.00 631.20 L 1019.30 638.90 L 1021.20 647.20 L 1022.30 654.60 L 1022.90 661.80 L 1022.80 668.80 L 1022.20 675.70 L 1021.00 682.50 L 1019.20 689.10 L 1016.90 695.70 L 1014.10 702.10 L 1010.80 708.40 L 1007.00 714.70 L 1002.80 720.60 L 998.10 726.50 L 993.00 732.20 L 987.40 737.80 L 981.30 743.30 L 973.50 749.70 L 965.10 755.90 L 956.00 761.90 L 946.20 767.70 L 936.30 773.00 L 926.00 778.00 L 915.10 782.70 L 903.80 787.10 L 892.30 791.10 L 880.60 794.80 L 868.50 798.10 L 856.10 801.10 L 843.60 803.60 L 831.00 805.70 L 818.30 807.50 L 805.40 808.80 L 792.40 809.70 L 779.50 810.10 L 766.60 810.20 L 753.70 809.70 L 740.80 808.80 L 728.10 807.40 L 715.60 805.60 L 703.20 803.20 L 691.00 800.30 L 679.00 797.00 L 667.40 793.10 L 656.10 788.60 Z",
    fill: "#f0f8ff",
    fillRule: "nonzero",
    "group-id": 1,
    "node-id": 180,
    stroke: "none",
    "target-height": 570.7,
    "target-width": 957.4,
    "target-x": 65.5,
    "target-y": 239.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 270.00 842.70 L 261.40 840.60 L 257.60 839.10 L 250.60 835.40 L 245.10 831.10 L 242.60 828.60 L 240.40 825.60 L 238.40 822.30 L 236.80 818.70 L 235.70 814.60 L 235.00 809.90 L 235.10 802.50 L 235.70 798.10 L 240.30 776.60 L 241.30 769.30 L 241.80 762.00 L 241.70 755.20 L 241.20 748.90 L 240.00 742.60 L 238.20 736.50 L 235.90 730.50 L 233.00 724.70 L 229.30 718.70 L 224.90 712.60 L 220.20 706.80 L 214.50 700.50 L 201.60 687.40 L 196.40 681.40 L 192.00 675.60 L 188.50 670.10 L 185.40 664.20 L 182.90 658.40 L 181.20 652.90 L 180.00 647.50 L 179.40 641.90 L 179.20 636.40 L 179.60 630.80 L 180.50 625.30 L 181.80 619.80 L 185.60 608.60 L 189.20 599.80 L 189.80 596.90 L 190.10 594.00 L 189.90 591.10 L 189.20 587.30 L 188.00 583.40 L 186.30 579.30 L 183.10 573.50 L 179.30 567.40 L 166.90 549.70 L 161.30 540.00 L 158.60 532.60 L 157.90 527.10 L 158.70 521.70 L 159.60 519.20 L 161.10 516.70 L 163.10 514.10 L 171.60 505.80 L 180.90 495.90 L 187.70 486.60 L 190.40 482.10 L 192.40 477.90 L 195.10 469.90 L 195.80 466.00 L 196.00 458.70 L 195.20 454.00 L 194.00 449.60 L 192.10 445.30 L 189.90 441.20 L 184.10 433.30 L 179.00 427.80 L 169.40 418.40 L 165.80 414.00 L 162.60 409.30 L 159.80 404.40 L 157.50 399.40 L 155.70 394.40 L 154.40 389.20 L 153.80 384.40 L 153.60 379.70 L 154.60 373.00 L 156.90 367.30 L 158.60 364.80 L 160.70 362.60 L 163.30 360.80 L 166.30 359.20 L 169.40 358.10 L 173.10 357.40 L 177.40 357.20 L 182.40 357.40 L 186.60 358.10 L 190.70 359.10 L 194.60 360.60 L 198.40 362.50 L 203.20 365.50 L 207.80 369.10 L 212.20 373.20 L 216.30 377.70 L 220.10 382.60 L 223.80 387.90 L 230.20 398.90 L 233.00 404.70 L 236.70 413.50 L 239.70 422.20 L 242.10 430.70 L 244.50 443.60 L 244.90 448.10 L 245.00 460.00 L 246.10 473.00 L 248.50 483.10 L 250.30 488.00 L 252.70 492.80 L 255.70 497.50 L 258.30 500.80 L 264.90 507.40 L 269.00 510.70 L 278.00 516.50 L 283.50 519.40 L 298.20 526.10 L 305.40 529.90 L 311.60 533.60 L 317.50 537.70 L 322.70 541.90 L 327.00 546.10 L 331.00 550.70 L 334.40 555.50 L 337.40 560.50 L 339.80 565.80 L 341.90 571.40 L 345.10 583.50 L 347.20 597.20 L 349.60 625.20 L 351.20 633.40 L 352.70 637.80 L 354.70 642.30 L 357.50 647.60 L 360.90 653.20 L 365.50 660.20 L 377.70 677.10 Z",
    fill: "#47b0aa",
    fillRule: "nonzero",
    "group-id": 1,
    "node-id": 182,
    stroke: "none",
    "target-height": 485.5,
    "target-width": 224.1,
    "target-x": 153.6,
    "target-y": 357.2
  }), /*#__PURE__*/React.createElement("g", {
    "node-id": 544
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 381.60 817.10 L 373.70 809.80 L 369.20 804.90 L 358.40 791.20 L 352.10 782.20 L 345.30 771.90 L 335.60 755.80 L 325.30 737.80 L 315.20 719.10 L 294.80 678.90 L 284.80 658.20 L 265.90 617.20 L 248.80 578.40 L 234.10 544.10 L 212.40 490.90 L 214.40 490.20 L 236.10 543.20 L 250.70 577.50 L 277.00 636.40 L 296.60 677.70 L 316.90 717.80 L 326.90 736.50 L 337.20 754.50 L 346.90 770.50 L 353.60 780.70 L 359.90 789.70 L 370.60 803.40 L 375.10 808.20 L 383.00 815.50 Z",
    fill: "#ffffff",
    fillOpacity: 0.5,
    fillRule: "nonzero",
    "group-id": "1,2",
    "node-id": 186,
    stroke: "none",
    "target-height": 326.89996,
    "target-width": 170.6,
    "target-x": 212.4,
    "target-y": 490.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 262.60 615.30 L 259.70 615.40 L 256.40 615.00 L 252.70 614.00 L 248.50 612.20 L 243.80 609.50 L 238.40 605.70 L 239.70 604.10 L 245.10 607.90 L 249.80 610.50 L 253.90 612.20 L 257.40 613.10 L 260.50 613.40 L 263.20 613.00 L 265.70 612.20 L 269.30 609.60 L 270.80 607.80 L 272.60 604.80 L 275.00 598.30 L 275.70 595.20 L 276.50 588.10 L 278.60 588.10 L 278.50 590.60 L 276.90 599.30 L 275.80 602.80 L 274.20 606.20 L 272.20 609.30 L 268.80 612.80 L 266.60 614.10 L 262.60 615.30 Z",
    fill: "#ffffff",
    fillOpacity: 0.5,
    fillRule: "nonzero",
    "group-id": "1,2",
    "node-id": 188,
    stroke: "none",
    "target-height": 27.300049,
    "target-width": 40.200012,
    "target-x": 238.4,
    "target-y": 588.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 235.20 551.50 L 232.20 551.70 L 228.90 551.30 L 225.20 550.20 L 221.00 548.40 L 216.30 545.70 L 210.90 542.00 L 212.20 540.30 L 217.70 544.10 L 222.40 546.80 L 226.40 548.50 L 230.00 549.40 L 233.00 549.60 L 235.80 549.30 L 238.20 548.40 L 241.90 545.80 L 243.30 544.10 L 245.10 541.10 L 247.50 534.50 L 248.20 531.50 L 249.10 524.30 L 251.20 524.30 L 251.00 526.80 L 249.50 535.50 L 248.30 539.00 L 246.80 542.40 L 244.80 545.60 L 241.30 549.00 L 239.20 550.30 L 235.20 551.50 Z",
    fill: "#ffffff",
    fillOpacity: 0.5,
    fillRule: "nonzero",
    "group-id": "1,2",
    "node-id": 190,
    stroke: "none",
    "target-height": 27.400024,
    "target-width": 40.300003,
    "target-x": 210.9,
    "target-y": 524.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 218.50 514.70 L 215.60 514.80 L 212.30 514.40 L 208.60 513.40 L 204.40 511.60 L 199.70 508.90 L 194.30 505.10 L 195.60 503.50 L 201.00 507.30 L 205.70 509.90 L 209.80 511.60 L 213.30 512.50 L 216.40 512.80 L 219.10 512.40 L 221.60 511.60 L 225.20 509.00 L 226.70 507.20 L 228.50 504.20 L 230.90 497.70 L 231.60 494.60 L 232.40 487.50 L 234.50 487.50 L 234.30 490.00 L 232.80 498.70 L 231.70 502.20 L 230.10 505.60 L 228.10 508.80 L 224.60 512.20 L 222.50 513.50 L 218.50 514.70 Z",
    fill: "#ffffff",
    fillOpacity: 0.5,
    fillRule: "nonzero",
    "group-id": "1,2",
    "node-id": 192,
    stroke: "none",
    "target-height": 27.299988,
    "target-width": 40.199997,
    "target-x": 194.3,
    "target-y": 487.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 250.40 586.30 L 247.90 586.40 L 245.20 586.10 L 242.10 585.20 L 238.60 583.80 L 234.70 581.50 L 230.20 578.40 L 231.50 576.70 L 236.00 579.90 L 239.80 582.00 L 243.10 583.40 L 246.00 584.20 L 248.60 584.40 L 250.80 584.10 L 252.80 583.40 L 255.80 581.30 L 258.40 577.40 L 260.40 572.00 L 261.70 563.60 L 263.80 563.60 L 263.60 565.70 L 262.40 572.90 L 260.10 578.70 L 258.50 581.30 L 255.50 584.20 L 253.70 585.30 L 250.40 586.30 Z",
    fill: "#ffffff",
    fillOpacity: 0.5,
    fillRule: "nonzero",
    "group-id": "1,2",
    "node-id": 194,
    stroke: "none",
    "target-height": 22.800049,
    "target-width": 33.59999,
    "target-x": 230.2,
    "target-y": 563.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 277.00 646.80 L 274.00 646.90 L 270.70 646.50 L 267.00 645.50 L 262.90 643.70 L 258.10 641.00 L 252.80 637.20 L 254.00 635.50 L 259.50 639.30 L 264.20 642.00 L 268.20 643.70 L 271.80 644.60 L 274.80 644.80 L 277.60 644.50 L 280.00 643.70 L 283.70 641.00 L 285.10 639.30 L 286.90 636.30 L 289.30 629.80 L 290.00 626.70 L 290.90 619.50 L 293.00 619.60 L 292.80 622.10 L 291.30 630.80 L 290.10 634.30 L 288.60 637.70 L 286.60 640.80 L 283.10 644.30 L 281.00 645.60 L 277.00 646.80 Z",
    fill: "#ffffff",
    fillOpacity: 0.5,
    fillRule: "nonzero",
    "group-id": "1,2",
    "node-id": 196,
    stroke: "none",
    "target-height": 27.400024,
    "target-width": 40.199997,
    "target-x": 252.8,
    "target-y": 619.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 291.00 684.30 L 288.00 684.40 L 284.70 684.10 L 281.00 683.00 L 276.90 681.20 L 272.10 678.50 L 266.70 674.80 L 268.00 673.10 L 273.50 676.90 L 278.20 679.50 L 282.20 681.20 L 285.80 682.10 L 288.80 682.40 L 291.60 682.10 L 294.00 681.20 L 297.70 678.60 L 299.10 676.80 L 300.90 673.90 L 303.30 667.30 L 304.00 664.20 L 304.90 657.10 L 307.00 657.10 L 306.80 659.60 L 305.30 668.30 L 304.10 671.80 L 302.60 675.20 L 300.60 678.30 L 297.10 681.80 L 295.00 683.10 L 291.00 684.30 Z",
    fill: "#ffffff",
    fillOpacity: 0.5,
    fillRule: "nonzero",
    "group-id": "1,2",
    "node-id": 198,
    stroke: "none",
    "target-height": 27.300049,
    "target-width": 40.299988,
    "target-x": 266.7,
    "target-y": 657.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 306.60 710.80 L 303.90 710.90 L 301.00 710.40 L 297.60 709.20 L 293.70 707.10 L 289.10 703.90 L 290.40 702.30 L 294.80 705.30 L 298.50 707.30 L 301.60 708.40 L 304.20 708.80 L 306.50 708.70 L 308.50 708.00 L 311.50 705.60 L 314.00 701.20 L 315.50 695.50 L 316.00 691.20 L 318.10 691.20 L 317.60 696.20 L 315.80 702.30 L 314.30 705.40 L 312.90 707.20 L 311.30 708.70 L 309.40 709.90 L 306.60 710.80 Z",
    fill: "#ffffff",
    fillOpacity: 0.5,
    fillRule: "nonzero",
    "group-id": "1,2",
    "node-id": 200,
    stroke: "none",
    "target-height": 19.700012,
    "target-width": 29,
    "target-x": 289.1,
    "target-y": 691.2
  })), /*#__PURE__*/React.createElement("path", {
    d: "M 324.90 691.60 L 310.60 691.90 L 295.70 691.70 L 278.50 690.80 L 269.60 690.00 L 260.90 688.80 L 252.50 687.30 L 245.00 685.40 L 240.20 683.80 L 236.20 682.00 L 232.90 680.10 L 230.50 678.40 L 228.70 676.60 L 227.40 674.70 L 226.50 672.70 L 225.50 668.80 L 224.20 660.60 L 222.70 634.90 L 221.10 626.40 L 219.80 622.20 L 218.10 618.20 L 215.80 614.20 L 212.90 610.30 L 210.60 607.60 L 204.30 602.10 L 195.10 595.90 L 185.70 588.70 L 179.30 583.00 L 158.90 563.00 L 154.90 559.60 L 149.60 556.30 L 147.30 555.50 L 144.90 555.20 L 142.50 555.60 L 140.10 556.60 L 137.50 558.30 L 135.50 560.20 L 134.00 562.20 L 133.00 564.30 L 132.30 566.50 L 132.10 571.50 L 132.50 574.30 L 133.60 578.00 L 135.10 581.80 L 137.20 586.10 L 141.00 592.20 L 145.60 598.70 L 160.00 616.60 L 163.20 621.50 L 165.70 626.10 L 167.70 630.90 L 169.10 635.50 L 170.10 639.90 L 170.60 644.40 L 170.60 652.50 L 169.90 658.30 L 168.70 663.40 L 164.40 676.70 L 163.70 680.70 L 163.50 684.40 L 163.80 688.00 L 164.60 691.50 L 165.70 694.80 L 168.10 699.50 L 171.00 704.30 L 181.30 718.90 L 186.60 728.20 L 189.90 736.80 L 191.00 741.40 L 191.70 746.50 L 192.20 754.50 L 193.90 760.90 L 197.30 768.00 L 202.60 775.60 L 206.00 779.30 L 209.90 783.00 L 214.20 786.30 L 219.10 789.30 L 224.70 792.10 L 228.90 793.70 L 238.70 796.20 L 244.30 797.00 L 249.70 797.40 L 255.70 797.30 L 262.10 796.80 L 269.10 795.80 L 275.80 794.40 L 283.00 792.30 L 290.90 789.60 L 299.40 786.20 Z",
    fill: "#59d1ba",
    fillRule: "nonzero",
    "group-id": 1,
    "node-id": 203,
    stroke: "none",
    "target-height": 242.20001,
    "target-width": 192.79999,
    "target-x": 132.1,
    "target-y": 555.2
  }), /*#__PURE__*/React.createElement("g", {
    "node-id": 545
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 304.40 785.30 L 297.00 782.30 L 292.30 779.60 L 285.30 775.10 L 277.30 769.30 L 260.70 755.70 L 243.50 740.30 L 226.90 724.40 L 211.90 709.60 L 188.40 685.20 L 189.10 684.60 L 212.60 709.00 L 227.50 723.80 L 244.10 739.60 L 261.30 754.90 L 277.80 768.50 L 285.80 774.30 L 292.70 778.80 L 297.40 781.50 L 304.70 784.50 Z",
    fill: "#ffffff",
    fillOpacity: 0.5,
    fillRule: "nonzero",
    "group-id": "1,3",
    "node-id": 207,
    stroke: "none",
    "target-height": 100.70001,
    "target-width": 116.30002,
    "target-x": 188.4,
    "target-y": 684.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 226.70 725.60 L 224.80 726.40 L 222.40 726.70 L 219.30 726.60 L 215.40 725.80 L 215.70 724.90 L 219.40 725.70 L 222.30 725.90 L 224.50 725.60 L 226.20 724.90 L 227.50 723.90 L 228.60 722.40 L 229.40 718.90 L 229.40 717.10 L 228.50 712.80 L 229.40 712.50 L 230.30 717.10 L 230.30 719.00 L 230.00 721.00 L 229.30 722.80 L 228.10 724.50 L 226.70 725.60 Z",
    fill: "#ffffff",
    fillOpacity: 0.5,
    fillRule: "nonzero",
    "group-id": "1,3",
    "node-id": 209,
    stroke: "none",
    "target-height": 14.200012,
    "target-width": 14.900009,
    "target-x": 215.4,
    "target-y": 712.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 206.40 705.20 L 204.50 705.90 L 202.10 706.30 L 199.00 706.10 L 195.00 705.30 L 195.30 704.50 L 199.10 705.20 L 201.90 705.40 L 204.20 705.10 L 205.90 704.40 L 207.20 703.50 L 208.20 702.00 L 209.00 698.40 L 209.00 696.60 L 208.20 692.30 L 209.00 692.00 L 209.90 696.70 L 210.00 698.60 L 209.70 700.50 L 209.00 702.40 L 207.80 704.00 L 206.40 705.20 Z",
    fill: "#ffffff",
    fillOpacity: 0.5,
    fillRule: "nonzero",
    "group-id": "1,3",
    "node-id": 211,
    stroke: "none",
    "target-height": 14.299988,
    "target-width": 15,
    "target-x": 195,
    "target-y": 692
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 194.30 693.50 L 192.40 694.20 L 190.00 694.60 L 186.90 694.40 L 183.00 693.60 L 183.20 692.80 L 187.00 693.50 L 189.80 693.70 L 192.10 693.40 L 193.80 692.70 L 195.10 691.80 L 196.10 690.30 L 196.90 686.70 L 196.90 684.90 L 196.10 680.60 L 196.90 680.30 L 197.80 685.00 L 197.80 686.90 L 197.60 688.80 L 196.90 690.70 L 195.70 692.30 L 194.30 693.50 Z",
    fill: "#ffffff",
    fillOpacity: 0.5,
    fillRule: "nonzero",
    "group-id": "1,3",
    "node-id": 213,
    stroke: "none",
    "target-height": 14.299988,
    "target-width": 14.800003,
    "target-x": 183,
    "target-y": 680.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 217.60 716.30 L 216.00 716.90 L 214.00 717.20 L 211.40 717.10 L 208.10 716.40 L 208.40 715.60 L 211.50 716.20 L 215.70 716.10 L 218.20 714.80 L 219.00 713.60 L 219.70 710.60 L 219.00 705.70 L 219.80 705.30 L 220.60 709.20 L 220.60 710.80 L 219.80 714.00 L 218.80 715.40 L 217.60 716.30 Z",
    fill: "#ffffff",
    fillOpacity: 0.5,
    fillRule: "nonzero",
    "group-id": "1,3",
    "node-id": 215,
    stroke: "none",
    "target-height": 11.900024,
    "target-width": 12.5,
    "target-x": 208.1,
    "target-y": 705.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 237.10 735.60 L 235.20 736.40 L 232.80 736.70 L 229.70 736.60 L 225.80 735.80 L 226.10 734.90 L 229.80 735.70 L 232.70 735.80 L 234.90 735.60 L 236.60 734.90 L 237.90 733.90 L 239.00 732.40 L 239.80 728.80 L 239.70 727.00 L 238.90 722.80 L 239.80 722.50 L 240.70 727.10 L 240.70 729.00 L 240.40 731.00 L 239.70 732.80 L 238.50 734.50 L 237.10 735.60 Z",
    fill: "#ffffff",
    fillOpacity: 0.5,
    fillRule: "nonzero",
    "group-id": "1,3",
    "node-id": 217,
    stroke: "none",
    "target-height": 14.200012,
    "target-width": 14.899994,
    "target-x": 225.8,
    "target-y": 722.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 248.20 748.00 L 246.30 748.70 L 243.90 749.10 L 240.80 748.90 L 236.90 748.20 L 237.20 747.30 L 240.90 748.10 L 243.80 748.20 L 246.00 747.90 L 247.70 747.30 L 249.00 746.30 L 250.10 744.80 L 250.90 741.20 L 250.80 739.40 L 250.00 735.20 L 250.90 734.90 L 251.80 739.50 L 251.80 741.40 L 251.50 743.40 L 250.80 745.20 L 249.60 746.90 L 248.20 748.00 Z",
    fill: "#ffffff",
    fillOpacity: 0.5,
    fillRule: "nonzero",
    "group-id": "1,3",
    "node-id": 219,
    stroke: "none",
    "target-height": 14.199951,
    "target-width": 14.900009,
    "target-x": 236.9,
    "target-y": 734.9
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 258.40 755.90 L 255.30 756.60 L 250.20 756.00 L 250.50 755.10 L 253.70 755.70 L 256.00 755.70 L 257.60 755.30 L 258.80 754.50 L 259.70 753.10 L 260.10 751.40 L 260.10 749.60 L 259.50 746.70 L 260.40 746.40 L 261.00 749.70 L 261.00 751.60 L 260.50 753.40 L 259.40 755.10 L 258.40 755.90 Z",
    fill: "#ffffff",
    fillOpacity: 0.5,
    fillRule: "nonzero",
    "group-id": "1,3",
    "node-id": 221,
    stroke: "none",
    "target-height": 10.199951,
    "target-width": 10.800003,
    "target-x": 250.2,
    "target-y": 746.4
  })), /*#__PURE__*/React.createElement("path", {
    d: "M 813.60 768.80 L 818.20 769.40 L 821.60 769.40 L 825.20 769.20 L 829.20 768.40 L 834.40 766.30 L 837.00 764.70 L 839.40 762.80 L 841.50 760.30 L 843.50 757.20 L 845.00 753.90 L 846.20 749.70 L 848.00 736.80 L 849.30 730.10 L 850.80 724.20 L 852.30 719.90 L 856.00 712.30 L 860.80 705.70 L 867.00 699.70 L 870.70 696.90 L 875.90 693.60 L 882.20 690.10 L 895.10 683.90 L 904.20 678.50 L 911.30 672.60 L 916.70 666.30 L 918.70 663.10 L 921.00 658.40 L 922.60 653.60 L 923.70 648.50 L 924.30 643.30 L 924.20 628.80 L 924.90 625.80 L 926.20 623.00 L 930.20 617.80 L 932.80 615.40 L 937.10 612.00 L 951.10 602.10 L 955.30 598.70 L 958.60 595.20 L 960.50 592.70 L 961.70 590.00 L 962.50 587.30 L 962.30 583.00 L 961.70 580.50 L 955.10 566.40 L 952.20 557.40 L 951.40 552.90 L 951.00 545.40 L 951.40 542.20 L 953.30 536.20 L 956.40 531.30 L 959.00 528.50 L 961.90 525.90 L 965.30 523.60 L 970.70 520.60 L 980.20 516.40 L 983.60 514.40 L 986.80 512.10 L 992.50 506.80 L 996.90 500.90 L 999.70 494.90 L 1000.50 491.80 L 1000.70 488.90 L 1000.50 486.10 L 999.70 483.40 L 998.30 480.90 L 996.30 478.50 L 994.50 477.10 L 989.60 474.60 L 986.20 473.50 L 982.90 472.90 L 976.10 472.90 L 972.70 473.40 L 968.20 474.70 L 963.80 476.40 L 959.30 478.70 L 955.10 481.40 L 946.90 487.70 L 941.30 493.10 L 936.20 498.80 L 931.60 504.70 L 928.00 510.20 L 924.90 515.70 L 920.60 526.70 L 917.70 532.90 L 915.40 536.80 L 912.70 540.40 L 909.60 543.70 L 904.10 548.00 L 900.60 549.90 L 892.80 552.90 L 883.00 554.80 L 869.10 556.00 L 862.30 557.10 L 856.60 558.40 L 850.90 560.30 L 846.00 562.60 L 841.70 565.20 L 837.70 568.30 L 834.00 571.80 L 830.70 575.80 L 827.70 580.10 L 821.80 590.50 L 812.40 610.30 L 808.30 616.00 L 801.50 622.20 L 796.50 626.00 L 782.90 635.30 Z",
    fill: "#47b0aa",
    fillRule: "nonzero",
    "group-id": 1,
    "node-id": 224,
    stroke: "none",
    "target-height": 296.50003,
    "target-width": 217.79999,
    "target-x": 782.9,
    "target-y": 472.9
  }), /*#__PURE__*/React.createElement("g", {
    "node-id": 546
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 747.00 725.50 L 751.90 723.60 L 757.60 720.80 L 764.30 716.80 L 777.80 707.50 L 797.00 692.20 L 821.60 670.30 L 846.80 646.20 L 882.50 610.00 L 903.20 588.20 L 935.00 553.40 L 933.90 552.40 L 902.20 587.10 L 881.60 608.90 L 858.20 632.80 L 833.40 657.10 L 808.50 680.20 L 796.30 690.90 L 784.90 700.20 L 770.20 711.20 L 757.10 719.40 L 751.50 722.20 L 746.60 724.20 Z",
    fill: "#ffffff",
    fillOpacity: 0.5,
    fillRule: "nonzero",
    "group-id": "1,4",
    "node-id": 228,
    stroke: "none",
    "target-height": 173.09998,
    "target-width": 188.40002,
    "target-x": 746.6,
    "target-y": 552.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 872.60 622.40 L 874.90 623.30 L 877.70 623.90 L 881.20 623.90 L 885.50 623.30 L 890.70 622.00 L 890.20 620.60 L 885.10 621.90 L 881.00 622.50 L 877.70 622.40 L 875.10 621.90 L 873.00 621.00 L 871.40 619.70 L 869.30 616.40 L 868.50 611.40 L 869.00 605.60 L 870.10 601.40 L 868.70 600.90 L 867.50 605.60 L 867.10 611.80 L 867.50 615.00 L 868.10 617.10 L 869.00 619.00 L 870.40 620.70 L 872.60 622.40 Z",
    fill: "#ffffff",
    fillOpacity: 0.5,
    fillRule: "nonzero",
    "group-id": "1,4",
    "node-id": 230,
    stroke: "none",
    "target-height": 23,
    "target-width": 23.600037,
    "target-x": 867.1,
    "target-y": 600.9
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 905.70 587.40 L 908.00 588.30 L 910.80 588.90 L 914.30 588.90 L 918.50 588.30 L 923.70 587.00 L 923.30 585.60 L 918.20 586.90 L 914.10 587.50 L 910.80 587.40 L 908.20 586.90 L 906.10 586.00 L 904.40 584.70 L 902.40 581.40 L 901.60 576.40 L 902.10 570.60 L 903.10 566.40 L 901.80 565.90 L 900.60 570.60 L 900.10 576.80 L 900.50 580.00 L 902.10 584.00 L 903.40 585.70 L 905.70 587.40 Z",
    fill: "#ffffff",
    fillOpacity: 0.5,
    fillRule: "nonzero",
    "group-id": "1,4",
    "node-id": 232,
    stroke: "none",
    "target-height": 23,
    "target-width": 23.600037,
    "target-x": 900.1,
    "target-y": 565.9
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 925.30 567.40 L 927.60 568.30 L 930.40 568.80 L 933.90 568.90 L 938.20 568.30 L 943.40 566.90 L 942.90 565.60 L 937.80 566.90 L 933.70 567.40 L 930.40 567.40 L 927.80 566.90 L 925.70 566.00 L 924.10 564.70 L 922.00 561.40 L 921.20 556.40 L 921.70 550.60 L 922.80 546.40 L 921.40 545.90 L 920.20 550.60 L 919.70 556.80 L 920.10 560.00 L 921.70 564.00 L 923.00 565.70 L 925.30 567.40 Z",
    fill: "#ffffff",
    fillOpacity: 0.5,
    fillRule: "nonzero",
    "group-id": "1,4",
    "node-id": 234,
    stroke: "none",
    "target-height": 23,
    "target-width": 23.700012,
    "target-x": 919.7,
    "target-y": 545.9
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 887.50 606.50 L 889.40 607.20 L 891.80 607.70 L 894.70 607.70 L 898.20 607.20 L 902.50 606.10 L 902.10 604.70 L 897.90 605.80 L 894.50 606.30 L 891.80 606.20 L 889.60 605.80 L 887.90 605.10 L 886.60 604.00 L 884.90 601.30 L 884.20 597.20 L 884.30 594.80 L 885.50 589.00 L 884.20 588.50 L 883.20 592.50 L 882.80 597.60 L 883.10 600.30 L 884.40 603.60 L 885.50 605.10 L 887.50 606.50 Z",
    fill: "#ffffff",
    fillOpacity: 0.5,
    fillRule: "nonzero",
    "group-id": "1,4",
    "node-id": 236,
    stroke: "none",
    "target-height": 19.200012,
    "target-width": 19.700012,
    "target-x": 882.8,
    "target-y": 588.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 855.80 639.50 L 858.10 640.40 L 860.90 640.90 L 864.40 641.00 L 868.60 640.40 L 873.80 639.10 L 873.40 637.70 L 868.30 639.00 L 864.20 639.60 L 860.90 639.50 L 858.30 639.00 L 856.20 638.10 L 854.50 636.80 L 852.50 633.50 L 852.00 631.50 L 851.70 628.50 L 852.20 622.70 L 853.20 618.50 L 851.90 618.00 L 850.70 622.70 L 850.20 628.90 L 850.60 632.10 L 851.20 634.20 L 852.20 636.10 L 853.50 637.80 L 855.80 639.50 Z",
    fill: "#ffffff",
    fillOpacity: 0.5,
    fillRule: "nonzero",
    "group-id": "1,4",
    "node-id": 238,
    stroke: "none",
    "target-height": 23,
    "target-width": 23.599976,
    "target-x": 850.2,
    "target-y": 618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 837.70 660.60 L 840.00 661.60 L 842.90 662.10 L 846.30 662.10 L 850.60 661.50 L 855.80 660.20 L 855.40 658.80 L 850.20 660.10 L 846.10 660.70 L 842.80 660.60 L 840.20 660.10 L 838.20 659.20 L 836.50 657.90 L 834.50 654.60 L 833.60 649.60 L 834.10 643.80 L 835.20 639.60 L 833.80 639.10 L 832.60 643.80 L 832.20 650.00 L 832.60 653.20 L 833.20 655.30 L 834.10 657.20 L 835.50 658.90 L 837.70 660.60 Z",
    fill: "#ffffff",
    fillOpacity: 0.5,
    fillRule: "nonzero",
    "group-id": "1,4",
    "node-id": 240,
    stroke: "none",
    "target-height": 23,
    "target-width": 23.599976,
    "target-x": 832.2,
    "target-y": 639.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 821.20 674.20 L 822.90 674.90 L 825.00 675.20 L 827.50 675.30 L 830.50 674.80 L 834.30 673.90 L 833.80 672.50 L 829.60 673.50 L 826.30 673.80 L 823.90 673.60 L 822.00 673.00 L 820.60 671.90 L 819.50 670.20 L 818.90 668.30 L 818.60 666.20 L 818.70 664.10 L 819.80 659.10 L 818.40 658.70 L 817.50 662.00 L 817.20 666.50 L 817.50 668.80 L 818.60 671.70 L 819.60 672.90 L 821.20 674.20 Z",
    fill: "#ffffff",
    fillOpacity: 0.5,
    fillRule: "nonzero",
    "group-id": "1,4",
    "node-id": 242,
    stroke: "none",
    "target-height": 16.599976,
    "target-width": 17.099976,
    "target-x": 817.2,
    "target-y": 658.7
  })), /*#__PURE__*/React.createElement("path", {
    d: "M 762.70 685.00 L 776.30 688.10 L 790.40 690.80 L 807.00 693.40 L 815.60 694.30 L 824.00 694.90 L 832.30 695.10 L 839.80 694.80 L 844.60 694.20 L 848.80 693.30 L 852.40 692.20 L 854.90 691.00 L 857.00 689.60 L 859.90 686.40 L 863.10 679.20 L 864.40 675.40 L 869.10 657.40 L 872.30 647.40 L 876.20 639.90 L 878.60 636.40 L 881.50 633.10 L 885.00 629.90 L 888.80 627.10 L 893.50 624.50 L 905.80 619.30 L 917.90 613.20 L 926.30 608.20 L 946.30 595.20 L 950.20 593.10 L 953.60 591.80 L 956.60 591.00 L 958.80 590.90 L 960.80 591.20 L 962.80 592.00 L 964.70 593.30 L 966.80 595.50 L 968.30 597.60 L 969.30 599.80 L 969.90 602.00 L 970.10 604.30 L 969.30 609.00 L 968.40 611.60 L 964.40 618.20 L 961.60 621.80 L 956.80 626.90 L 951.20 632.20 L 934.00 646.30 L 930.00 650.30 L 926.70 654.20 L 923.90 658.40 L 921.60 662.50 L 919.80 666.40 L 918.50 670.60 L 916.90 678.30 L 916.40 683.90 L 916.50 689.00 L 918.00 702.40 L 917.90 706.40 L 917.30 709.90 L 916.30 713.30 L 914.90 716.40 L 913.20 719.30 L 910.00 723.40 L 906.30 727.30 L 893.60 739.10 L 886.70 746.90 L 882.00 754.50 L 880.00 758.60 L 878.30 763.30 L 876.30 770.80 L 873.40 776.60 L 868.80 782.60 L 862.30 788.80 L 858.40 791.60 L 853.90 794.30 L 849.20 796.60 L 843.90 798.50 L 838.10 800.00 L 833.70 800.80 L 823.90 801.20 L 818.50 800.90 L 813.30 800.10 L 807.70 798.90 L 801.70 797.20 L 795.20 794.80 L 789.10 792.10 L 782.70 788.80 L 775.70 784.70 L 768.30 779.80 Z",
    fill: "#59d1ba",
    fillRule: "nonzero",
    "group-id": 1,
    "node-id": 245,
    stroke: "none",
    "target-height": 210.29999,
    "target-width": 207.39996,
    "target-x": 762.7,
    "target-y": 590.9
  }), /*#__PURE__*/React.createElement("g", {
    "node-id": 547
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 763.80 777.90 L 767.70 777.40 L 772.40 776.20 L 778.20 774.20 L 786.90 770.60 L 797.00 765.80 L 807.30 760.40 L 818.30 754.30 L 840.00 741.30 L 860.30 728.40 L 893.60 705.80 L 893.00 705.10 L 859.80 727.60 L 839.50 740.50 L 817.90 753.50 L 807.00 759.60 L 796.80 765.00 L 786.70 769.80 L 778.00 773.40 L 772.30 775.40 L 767.50 776.50 L 763.70 777.10 Z",
    fill: "#ffffff",
    fillOpacity: 0.5,
    fillRule: "nonzero",
    "group-id": "1,5",
    "node-id": 249,
    stroke: "none",
    "target-height": 72.80005,
    "target-width": 129.89996,
    "target-x": 763.7,
    "target-y": 705.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 849.20 736.60 L 850.80 737.70 L 853.10 738.50 L 856.00 738.90 L 859.90 739.00 L 859.80 738.10 L 856.10 738.10 L 853.40 737.70 L 851.30 737.00 L 849.80 736.00 L 848.80 734.90 L 848.10 733.20 L 848.00 729.70 L 848.40 728.00 L 850.00 724.10 L 849.30 723.60 L 847.50 727.90 L 847.10 729.70 L 847.30 733.50 L 848.10 735.30 L 849.20 736.60 Z",
    fill: "#ffffff",
    fillOpacity: 0.5,
    fillRule: "nonzero",
    "group-id": "1,5",
    "node-id": 251,
    stroke: "none",
    "target-height": 15.400024,
    "target-width": 12.800049,
    "target-x": 847.1,
    "target-y": 723.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 872.60 721.20 L 874.20 722.30 L 876.40 723.10 L 879.40 723.50 L 883.30 723.60 L 883.20 722.70 L 879.50 722.70 L 876.70 722.30 L 874.70 721.60 L 873.20 720.60 L 872.20 719.50 L 871.40 717.80 L 871.40 714.30 L 871.70 712.60 L 873.40 708.70 L 872.60 708.20 L 870.80 712.50 L 870.50 714.30 L 870.30 716.20 L 870.60 718.10 L 871.40 719.90 L 872.60 721.20 Z",
    fill: "#ffffff",
    fillOpacity: 0.5,
    fillRule: "nonzero",
    "group-id": "1,5",
    "node-id": 253,
    stroke: "none",
    "target-height": 15.399963,
    "target-width": 13,
    "target-x": 870.3,
    "target-y": 708.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 886.30 712.50 L 888.00 713.60 L 890.20 714.40 L 893.10 714.80 L 897.00 714.80 L 896.90 714.00 L 893.20 714.00 L 890.50 713.60 L 888.40 712.90 L 887.00 711.90 L 885.90 710.70 L 885.20 709.10 L 885.10 705.50 L 885.50 703.90 L 887.20 700.00 L 886.40 699.50 L 884.60 703.70 L 884.20 705.50 L 884.40 709.40 L 885.20 711.20 L 886.30 712.50 Z",
    fill: "#ffffff",
    fillOpacity: 0.5,
    fillRule: "nonzero",
    "group-id": "1,5",
    "node-id": 255,
    stroke: "none",
    "target-height": 15.299988,
    "target-width": 12.799988,
    "target-x": 884.2,
    "target-y": 699.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 859.70 729.50 L 861.10 730.50 L 862.90 731.10 L 865.40 731.50 L 868.70 731.60 L 868.50 730.70 L 864.90 730.60 L 862.30 730.10 L 860.60 729.20 L 859.50 728.00 L 858.90 726.70 L 858.80 723.80 L 860.50 719.20 L 859.70 718.70 L 857.90 723.80 L 858.00 727.00 L 858.70 728.50 L 859.70 729.50 Z",
    fill: "#ffffff",
    fillOpacity: 0.5,
    fillRule: "nonzero",
    "group-id": "1,5",
    "node-id": 257,
    stroke: "none",
    "target-height": 12.899963,
    "target-width": 10.799988,
    "target-x": 857.9,
    "target-y": 718.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 837.40 744.00 L 839.00 745.10 L 841.30 745.90 L 844.20 746.30 L 848.10 746.40 L 848.00 745.50 L 844.30 745.50 L 841.50 745.10 L 839.50 744.40 L 838.00 743.40 L 837.00 742.30 L 836.30 740.60 L 836.20 737.10 L 836.60 735.40 L 838.20 731.50 L 837.50 731.00 L 835.70 735.30 L 835.30 737.10 L 835.20 739.00 L 835.50 740.90 L 836.30 742.70 L 837.40 744.00 Z",
    fill: "#ffffff",
    fillOpacity: 0.5,
    fillRule: "nonzero",
    "group-id": "1,5",
    "node-id": 259,
    stroke: "none",
    "target-height": 15.400024,
    "target-width": 12.899963,
    "target-x": 835.2,
    "target-y": 731
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 824.40 753.60 L 826.10 754.70 L 828.30 755.50 L 831.30 756.00 L 835.10 756.00 L 835.00 755.10 L 831.30 755.10 L 828.60 754.70 L 826.50 754.00 L 825.10 753.00 L 824.00 751.90 L 823.30 750.20 L 823.20 746.70 L 823.60 745.00 L 825.30 741.10 L 824.50 740.60 L 822.70 744.90 L 822.30 746.70 L 822.50 750.50 L 823.30 752.30 L 824.40 753.60 Z",
    fill: "#ffffff",
    fillOpacity: 0.5,
    fillRule: "nonzero",
    "group-id": "1,5",
    "node-id": 261,
    stroke: "none",
    "target-height": 15.400024,
    "target-width": 12.799988,
    "target-x": 822.3,
    "target-y": 740.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 813.20 759.00 L 816.00 760.40 L 820.90 760.70 L 820.80 759.80 L 817.70 759.80 L 815.50 759.30 L 814.10 758.60 L 813.10 757.60 L 812.50 756.10 L 812.50 754.40 L 814.00 750.10 L 813.20 749.60 L 812.00 752.60 L 811.60 754.40 L 811.70 756.30 L 812.40 758.00 L 813.20 759.00 Z",
    fill: "#ffffff",
    fillOpacity: 0.5,
    fillRule: "nonzero",
    "group-id": "1,5",
    "node-id": 263,
    stroke: "none",
    "target-height": 11.100037,
    "target-width": 9.300049,
    "target-x": 811.6,
    "target-y": 749.6
  })), /*#__PURE__*/React.createElement("path", {
    d: "M 190.40 382.30 L 190.70 385.10 L 191.50 387.80 L 192.80 390.20 L 194.60 392.40 L 196.70 394.20 L 199.20 395.50 L 201.90 396.30 L 204.70 396.60 L 518.80 396.60 L 521.40 396.40 L 523.80 395.70 L 526.00 394.70 L 528.00 393.20 L 529.70 391.50 L 531.10 389.50 L 532.20 387.30 L 532.80 384.90 L 533.10 382.30 L 533.10 185.30 L 532.80 182.70 L 532.20 180.30 L 531.10 178.10 L 529.70 176.10 L 528.00 174.40 L 526.00 173.00 L 523.80 171.90 L 521.40 171.20 L 518.80 171.00 L 204.70 171.00 L 201.90 171.30 L 199.20 172.10 L 196.70 173.40 L 194.60 175.20 L 192.80 177.40 L 191.50 179.80 L 190.70 182.50 L 190.40 185.30 Z",
    fill: "#cee8ef",
    fillRule: "nonzero",
    "group-id": 1,
    "node-id": 266,
    stroke: "none",
    "target-height": 225.6,
    "target-width": 342.69998,
    "target-x": 190.4,
    "target-y": 171
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 204.70 171.00 L 518.80 171.00 L 521.40 171.20 L 523.80 171.90 L 526.00 173.00 L 528.00 174.40 L 529.70 176.10 L 531.10 178.10 L 532.20 180.30 L 532.80 182.70 L 533.10 185.30 L 533.10 211.90 L 190.40 211.90 L 190.40 185.30 L 190.70 182.50 L 191.50 179.80 L 192.80 177.40 L 194.60 175.20 L 196.70 173.40 L 199.20 172.10 L 201.90 171.30 L 204.70 171.00 Z",
    fill: "#b7d9f7",
    fillRule: "nonzero",
    "group-id": 1,
    "node-id": 268,
    stroke: "none",
    "target-height": 40.899994,
    "target-width": 342.69998,
    "target-x": 190.4,
    "target-y": 171
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 498.40 191.60 L 498.70 193.50 L 499.40 195.20 L 500.50 196.60 L 501.90 197.70 L 503.60 198.40 L 505.50 198.70 L 507.40 198.40 L 509.10 197.70 L 510.50 196.60 L 511.60 195.20 L 512.40 193.50 L 512.60 191.60 L 512.40 189.70 L 511.60 188.00 L 510.50 186.60 L 509.10 185.50 L 507.40 184.70 L 505.50 184.50 L 502.80 185.00 L 500.50 186.60 L 498.90 188.90 L 498.40 191.60 Z",
    fill: "#ffffff",
    fillRule: "nonzero",
    "group-id": 1,
    "node-id": 270,
    stroke: "none",
    "target-height": 14.199997,
    "target-width": 14.199982,
    "target-x": 498.4,
    "target-y": 184.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 480.50 191.60 L 480.70 193.50 L 481.40 195.20 L 482.50 196.60 L 484.00 197.70 L 485.70 198.40 L 487.60 198.70 L 489.50 198.40 L 491.10 197.70 L 492.60 196.60 L 493.70 195.20 L 494.40 193.50 L 494.70 191.60 L 494.40 189.70 L 493.70 188.00 L 492.60 186.60 L 491.20 185.50 L 489.50 184.70 L 487.60 184.50 L 484.80 185.00 L 482.50 186.60 L 481.00 188.90 L 480.50 191.60 Z",
    fill: "#ffffff",
    fillRule: "nonzero",
    "group-id": 1,
    "node-id": 272,
    stroke: "none",
    "target-height": 14.199997,
    "target-width": 14.200012,
    "target-x": 480.5,
    "target-y": 184.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 463.10 191.60 L 463.40 193.50 L 464.10 195.20 L 465.20 196.60 L 466.70 197.70 L 468.30 198.40 L 470.20 198.70 L 472.10 198.40 L 473.80 197.70 L 475.30 196.60 L 476.40 195.20 L 477.10 193.50 L 477.30 191.60 L 477.10 189.70 L 476.40 188.00 L 475.30 186.60 L 473.80 185.50 L 472.20 184.70 L 470.30 184.50 L 467.50 185.00 L 465.20 186.60 L 463.70 188.90 L 463.10 191.60 Z",
    fill: "#ffffff",
    fillRule: "nonzero",
    "group-id": 1,
    "node-id": 274,
    stroke: "none",
    "target-height": 14.199997,
    "target-width": 14.199982,
    "target-x": 463.1,
    "target-y": 184.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 204.20 382.30 L 204.50 385.10 L 205.30 387.80 L 206.60 390.20 L 208.40 392.40 L 210.60 394.20 L 213.00 395.50 L 215.70 396.30 L 218.50 396.60 L 532.60 396.60 L 535.20 396.40 L 537.60 395.70 L 539.80 394.70 L 541.90 393.20 L 543.60 391.50 L 545.00 389.50 L 546.00 387.30 L 546.70 384.90 L 546.90 382.30 L 546.90 185.30 L 546.70 182.70 L 546.00 180.30 L 545.00 178.10 L 543.60 176.10 L 541.80 174.40 L 539.80 173.00 L 537.60 171.90 L 535.20 171.20 L 532.60 171.00 L 218.50 171.00 L 215.70 171.30 L 213.00 172.10 L 210.60 173.40 L 208.40 175.20 L 206.60 177.40 L 205.30 179.80 L 204.50 182.50 L 204.20 185.30 Z",
    fill: "#ebf3ff",
    fillRule: "nonzero",
    "group-id": 1,
    "node-id": 276,
    stroke: "none",
    "target-height": 225.6,
    "target-width": 342.7,
    "target-x": 204.2,
    "target-y": 171
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 218.50 171.00 L 532.60 171.00 L 535.20 171.20 L 537.60 171.90 L 539.80 173.00 L 541.90 174.40 L 543.60 176.10 L 545.00 178.10 L 546.00 180.30 L 546.70 182.70 L 546.90 185.30 L 546.90 211.90 L 204.20 211.90 L 204.20 185.30 L 204.50 182.50 L 205.30 179.80 L 206.60 177.40 L 208.40 175.20 L 210.60 173.40 L 213.00 172.10 L 215.70 171.30 L 218.50 171.00 Z",
    fill: "#b3d0ff",
    fillRule: "nonzero",
    "group-id": 1,
    "node-id": 278,
    stroke: "none",
    "target-height": 40.899994,
    "target-width": 342.7,
    "target-x": 204.2,
    "target-y": 171
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 512.20 191.60 L 512.50 193.50 L 513.20 195.20 L 514.30 196.60 L 515.80 197.70 L 517.40 198.40 L 519.40 198.70 L 521.30 198.40 L 522.90 197.70 L 524.40 196.60 L 525.50 195.20 L 526.20 193.50 L 526.50 191.60 L 526.20 189.70 L 525.50 188.00 L 524.40 186.60 L 522.90 185.50 L 521.30 184.70 L 519.40 184.50 L 516.60 185.00 L 514.30 186.60 L 512.80 188.90 L 512.20 191.60 Z",
    fill: "#b3d0ff",
    fillRule: "nonzero",
    "group-id": 1,
    "node-id": 280,
    stroke: "none",
    "target-height": 14.199997,
    "target-width": 14.299988,
    "target-x": 512.2,
    "target-y": 184.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 494.30 191.60 L 494.50 193.50 L 495.30 195.20 L 496.40 196.60 L 497.80 197.70 L 499.50 198.40 L 501.40 198.70 L 503.30 198.40 L 505.00 197.70 L 506.40 196.60 L 507.50 195.20 L 508.30 193.50 L 508.50 191.60 L 508.30 189.70 L 507.50 188.00 L 506.40 186.60 L 505.00 185.50 L 503.30 184.70 L 501.40 184.50 L 498.70 185.00 L 496.40 186.60 L 494.80 188.90 L 494.30 191.60 Z",
    fill: "#b3d0ff",
    fillRule: "nonzero",
    "group-id": 1,
    "node-id": 282,
    stroke: "none",
    "target-height": 14.199997,
    "target-width": 14.200012,
    "target-x": 494.3,
    "target-y": 184.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 477.00 191.60 L 477.30 193.50 L 478.00 195.20 L 479.10 196.60 L 480.50 197.70 L 482.20 198.40 L 484.10 198.70 L 486.00 198.40 L 487.70 197.70 L 489.10 196.60 L 490.20 195.20 L 491.00 193.50 L 491.20 191.60 L 491.00 189.70 L 490.30 188.00 L 489.10 186.60 L 487.70 185.50 L 486.00 184.70 L 484.10 184.50 L 481.40 185.00 L 479.10 186.60 L 477.50 188.90 L 477.00 191.60 Z",
    fill: "#b3d0ff",
    fillRule: "nonzero",
    "group-id": 1,
    "node-id": 284,
    stroke: "none",
    "target-height": 14.199997,
    "target-width": 14.200012,
    "target-x": 477,
    "target-y": 184.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 414.70 312.50 L 296.20 312.20 L 293.40 311.90 L 290.80 311.20 L 288.50 310.10 L 286.40 308.60 L 284.60 306.80 L 283.10 304.60 L 281.90 302.30 L 281.30 299.70 L 281.00 296.90 L 281.40 136.90 L 281.70 133.90 L 282.60 131.10 L 284.00 128.50 L 285.90 126.20 L 288.30 124.30 L 290.90 122.90 L 293.70 122.00 L 296.70 121.70 L 403.50 122.00 L 404.40 122.30 L 430.30 144.60 L 430.00 297.30 L 429.70 300.30 L 428.80 303.20 L 427.40 305.80 L 425.50 308.10 L 423.20 310.00 L 420.50 311.40 L 417.70 312.20 L 414.70 312.50 Z",
    fill: "#5fb7ff",
    fillRule: "nonzero",
    "group-id": 1,
    "node-id": 286,
    stroke: "none",
    "target-height": 190.8,
    "target-width": 149.29999,
    "target-x": 281,
    "target-y": 121.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 404.00 122.00 L 403.90 144.50 L 430.40 144.60 L 404.00 122.00 Z",
    fill: "#45a2ff",
    fillRule: "nonzero",
    "group-id": 1,
    "node-id": 288,
    stroke: "none",
    "target-height": 22.600006,
    "target-width": 26.5,
    "target-x": 403.9,
    "target-y": 122
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 412.50 194.30 L 299.00 194.00 L 297.90 193.50 L 297.40 192.40 L 297.50 188.90 L 298.40 188.00 L 412.50 188.10 L 413.60 188.60 L 414.10 189.80 L 414.00 193.30 L 413.60 193.80 L 412.50 194.30 Z",
    fill: "#45a2ff",
    fillRule: "nonzero",
    "group-id": 1,
    "node-id": 290,
    stroke: "none",
    "target-height": 6.300003,
    "target-width": 116.70001,
    "target-x": 297.4,
    "target-y": 188
  }), /*#__PURE__*/React.createElement("g", {
    "node-id": 548
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 297.30 204.30 L 297.40 198.70 L 297.60 198.50 L 414.00 198.80 L 414.10 204.60 L 413.80 204.90 L 297.60 204.60 L 297.30 204.30 Z",
    fill: "#45a2ff",
    fillRule: "nonzero",
    "group-id": "1,6",
    "node-id": 294,
    stroke: "none",
    "target-height": 6.399994,
    "target-width": 116.80002,
    "target-x": 297.3,
    "target-y": 198.5
  })), /*#__PURE__*/React.createElement("g", {
    "node-id": 549
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 297.30 225.50 L 297.30 219.90 L 297.60 219.60 L 413.90 220.00 L 414.00 225.80 L 413.70 226.10 L 297.60 225.80 L 297.30 225.50 Z",
    fill: "#45a2ff",
    fillRule: "nonzero",
    "group-id": "1,7",
    "node-id": 299,
    stroke: "none",
    "target-height": 6.5,
    "target-width": 116.70001,
    "target-x": 297.3,
    "target-y": 219.6
  })), /*#__PURE__*/React.createElement("g", {
    "node-id": 550
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 297.30 236.10 L 297.30 230.50 L 297.60 230.20 L 413.70 230.50 L 414.00 230.80 L 414.00 236.40 L 413.70 236.70 L 297.60 236.40 L 297.30 236.10 Z",
    fill: "#45a2ff",
    fillRule: "nonzero",
    "group-id": "1,8",
    "node-id": 304,
    stroke: "none",
    "target-height": 6.5,
    "target-width": 116.70001,
    "target-x": 297.3,
    "target-y": 230.2
  })), /*#__PURE__*/React.createElement("g", {
    "node-id": 551
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 296.40 286.30 L 296.40 280.70 L 296.70 280.50 L 412.80 280.50 L 413.10 280.70 L 413.10 286.30 L 412.80 286.60 L 296.70 286.60 L 296.40 286.30 Z",
    fill: "#45a2ff",
    fillRule: "nonzero",
    "group-id": "1,9",
    "node-id": 309,
    stroke: "none",
    "target-height": 6.100006,
    "target-width": 116.70001,
    "target-x": 296.4,
    "target-y": 280.5
  })), /*#__PURE__*/React.createElement("g", {
    "node-id": 552
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 297.30 297.50 L 297.30 291.90 L 297.60 291.60 L 413.90 292.00 L 414.00 297.80 L 413.70 298.10 L 297.60 297.80 L 297.30 297.50 Z",
    fill: "#45a2ff",
    fillRule: "nonzero",
    "group-id": "1,10",
    "node-id": 314,
    stroke: "none",
    "target-height": 6.5,
    "target-width": 116.70001,
    "target-x": 297.3,
    "target-y": 291.6
  })), /*#__PURE__*/React.createElement("g", {
    "node-id": 553
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 296.40 158.20 L 296.40 152.70 L 296.70 152.40 L 413.00 152.50 L 413.10 158.20 L 412.80 158.50 L 296.70 158.50 L 296.40 158.20 Z",
    fill: "#45a2ff",
    fillRule: "nonzero",
    "group-id": "1,11",
    "node-id": 319,
    stroke: "none",
    "target-height": 6.100006,
    "target-width": 116.70001,
    "target-x": 296.4,
    "target-y": 152.4
  })), /*#__PURE__*/React.createElement("g", {
    "node-id": 554
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 297.30 169.10 L 297.30 163.50 L 297.60 163.20 L 413.70 163.50 L 414.00 163.80 L 414.00 169.40 L 413.70 169.60 L 297.60 169.30 L 297.30 169.10 Z",
    fill: "#45a2ff",
    fillRule: "nonzero",
    "group-id": "1,12",
    "node-id": 324,
    stroke: "none",
    "target-height": 6.400009,
    "target-width": 116.70001,
    "target-x": 297.3,
    "target-y": 163.2
  })), /*#__PURE__*/React.createElement("g", {
    "node-id": 555
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 297.20 257.20 L 297.20 251.70 L 297.50 251.40 L 413.80 251.80 L 413.90 257.50 L 413.60 257.80 L 297.50 257.50 L 297.20 257.20 Z",
    fill: "#45a2ff",
    fillRule: "nonzero",
    "group-id": "1,13",
    "node-id": 329,
    stroke: "none",
    "target-height": 6.399994,
    "target-width": 116.69998,
    "target-x": 297.2,
    "target-y": 251.4
  })), /*#__PURE__*/React.createElement("g", {
    "node-id": 556
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 297.20 267.80 L 297.20 262.20 L 297.50 262.00 L 413.60 262.30 L 413.90 262.50 L 413.90 268.10 L 413.60 268.40 L 297.50 268.10 L 297.20 267.80 Z",
    fill: "#45a2ff",
    fillRule: "nonzero",
    "group-id": "1,14",
    "node-id": 334,
    stroke: "none",
    "target-height": 6.399994,
    "target-width": 116.69998,
    "target-x": 297.2,
    "target-y": 262
  })), /*#__PURE__*/React.createElement("path", {
    d: "M 258.70 180.80 L 416.10 180.80 L 416.80 181.10 L 417.10 181.80 L 417.10 209.60 L 416.80 210.30 L 416.10 210.60 L 258.70 210.60 L 258.00 210.30 L 257.70 209.60 L 257.70 181.80 L 258.00 181.10 L 258.70 180.80 Z",
    fill: "#d4e6ed",
    fillRule: "nonzero",
    "group-id": 1,
    "node-id": 337,
    stroke: "none",
    "target-height": 29.800003,
    "target-width": 159.4,
    "target-x": 257.7,
    "target-y": 180.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 269.00 192.70 L 386.70 192.70 L 387.40 193.40 L 387.40 199.40 L 386.70 200.10 L 269.00 200.10 L 268.30 199.40 L 268.30 193.40 L 269.00 192.70 Z",
    fill: "#ffffff",
    fillRule: "nonzero",
    "group-id": 1,
    "node-id": 339,
    stroke: "none",
    "target-height": 7.400009,
    "target-width": 119.100006,
    "target-x": 268.3,
    "target-y": 192.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 411.30 196.40 L 410.90 198.70 L 410.10 200.70 L 408.80 202.40 L 407.00 203.70 L 405.00 204.60 L 402.70 204.90 L 400.50 204.60 L 398.40 203.70 L 396.70 202.40 L 395.40 200.70 L 394.50 198.70 L 394.20 196.40 L 394.50 194.10 L 395.40 192.10 L 396.70 190.40 L 398.40 189.10 L 400.50 188.20 L 402.70 187.90 L 405.00 188.20 L 407.00 189.10 L 408.80 190.40 L 410.10 192.10 L 410.90 194.10 L 411.30 196.40 Z",
    fill: "#ffffff",
    fillRule: "nonzero",
    "group-id": 1,
    "node-id": 341,
    stroke: "none",
    "target-height": 17,
    "target-width": 17.099976,
    "target-x": 394.2,
    "target-y": 187.9
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 258.70 242.50 L 416.10 242.50 L 416.80 242.80 L 417.10 243.50 L 417.10 271.30 L 416.80 272.00 L 416.10 272.30 L 258.70 272.30 L 258.00 272.00 L 257.70 271.30 L 257.70 243.50 L 258.00 242.80 L 258.70 242.50 Z",
    fill: "#d4e6ed",
    fillRule: "nonzero",
    "group-id": 1,
    "node-id": 343,
    stroke: "none",
    "target-height": 29.799988,
    "target-width": 159.4,
    "target-x": 257.7,
    "target-y": 242.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 269.00 254.40 L 386.70 254.40 L 387.40 255.00 L 387.20 261.60 L 269.00 261.80 L 268.30 261.10 L 268.30 255.00 L 269.00 254.40 Z",
    fill: "#ffffff",
    fillRule: "nonzero",
    "group-id": 1,
    "node-id": 345,
    stroke: "none",
    "target-height": 7.399994,
    "target-width": 119.100006,
    "target-x": 268.3,
    "target-y": 254.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 411.30 258.10 L 411.10 259.70 L 409.80 262.80 L 407.50 265.10 L 404.40 266.40 L 401.10 266.40 L 398.00 265.10 L 395.70 262.80 L 394.40 259.70 L 394.40 256.40 L 395.70 253.30 L 398.00 251.00 L 401.10 249.70 L 404.40 249.70 L 407.50 251.00 L 409.80 253.30 L 411.10 256.40 L 411.30 258.10 Z",
    fill: "#ffffff",
    fillRule: "nonzero",
    "group-id": 1,
    "node-id": 347,
    stroke: "none",
    "target-height": 16.699997,
    "target-width": 16.899994,
    "target-x": 394.4,
    "target-y": 249.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 365.00 219.20 L 352.90 220.20 L 344.60 229.00 L 343.50 229.90 L 342.30 230.50 L 340.90 230.60 L 339.50 230.30 L 338.30 229.60 L 337.40 228.60 L 336.80 227.30 L 336.70 225.90 L 337.20 197.20 L 337.40 195.90 L 338.70 193.80 L 341.10 192.60 L 343.60 192.90 L 344.80 193.60 L 368.40 212.20 L 369.00 213.40 L 369.30 214.80 L 369.10 216.20 L 367.50 218.30 L 366.30 219.00 L 365.00 219.20 Z",
    fill: "#2c4a7e",
    fillRule: "nonzero",
    "group-id": 1,
    "node-id": 349,
    stroke: "none",
    "target-height": 38,
    "target-width": 32.599976,
    "target-x": 336.7,
    "target-y": 192.6
  }), /*#__PURE__*/React.createElement("g", {
    "node-id": 557
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 343.10 210.60 L 351.50 206.50 L 352.30 206.50 L 352.80 207.00 L 369.10 241.00 L 369.20 241.80 L 368.70 242.40 L 360.30 246.40 L 359.50 246.40 L 359.00 245.90 L 342.60 211.90 L 342.60 211.10 L 343.10 210.60 Z",
    fill: "#2c4a7e",
    fillRule: "nonzero",
    "group-id": "1,15",
    "node-id": 353,
    stroke: "none",
    "target-height": 39.899994,
    "target-width": 26.600006,
    "target-x": 342.6,
    "target-y": 206.5
  })), /*#__PURE__*/React.createElement("path", {
    d: "M 997.00 863.60 L 996.70 865.20 L 995.80 866.80 L 994.10 868.60 L 991.40 870.60 L 987.30 872.70 L 976.60 876.80 L 959.60 881.30 L 932.90 886.40 L 915.70 889.00 L 879.20 893.50 L 857.60 895.70 L 824.50 898.60 L 787.10 901.20 L 748.50 903.50 L 706.30 905.40 L 663.00 906.90 L 616.90 908.10 L 570.00 908.80 L 521.00 909.00 L 472.00 908.80 L 425.10 908.10 L 379.00 906.90 L 335.70 905.40 L 293.50 903.50 L 254.90 901.20 L 217.50 898.60 L 184.40 895.70 L 162.80 893.50 L 126.30 889.00 L 109.10 886.40 L 82.40 881.30 L 65.40 876.80 L 54.70 872.70 L 50.60 870.60 L 47.90 868.60 L 46.20 866.80 L 45.30 865.20 L 45.00 863.60 L 45.30 862.00 L 46.20 860.40 L 47.90 858.60 L 50.60 856.60 L 54.70 854.40 L 65.40 850.40 L 82.40 845.90 L 109.10 840.80 L 126.30 838.20 L 162.80 833.70 L 184.40 831.50 L 217.50 828.60 L 254.90 825.90 L 293.50 823.70 L 335.70 821.70 L 379.00 820.20 L 425.10 819.10 L 472.00 818.40 L 521.00 818.20 L 570.00 818.40 L 616.90 819.10 L 663.00 820.20 L 706.30 821.70 L 748.50 823.70 L 787.10 825.90 L 824.50 828.60 L 857.60 831.50 L 879.20 833.70 L 915.70 838.20 L 932.90 840.80 L 959.60 845.90 L 976.60 850.40 L 987.30 854.40 L 991.40 856.60 L 994.10 858.60 L 995.80 860.40 L 996.70 862.00 L 997.00 863.60 Z",
    fill: "#d7e4f9",
    fillRule: "nonzero",
    "group-id": 1,
    "node-id": 356,
    stroke: "none",
    "target-height": 90.79999,
    "target-width": 952,
    "target-x": 45,
    "target-y": 818.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 292.20 832.80 L 805.30 832.80 L 897.20 460.00 L 393.40 460.00 L 292.20 832.80 Z",
    fill: "#142480",
    fillRule: "nonzero",
    "group-id": 1,
    "node-id": 358,
    stroke: "none",
    "target-height": 372.8,
    "target-width": 605,
    "target-x": 292.2,
    "target-y": 460
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 806.70 834.60 L 289.90 834.60 L 392.10 458.20 L 899.40 458.20 Z M 294.50 831.10 L 803.90 831.10 L 894.90 461.80 L 394.80 461.80 Z",
    fill: "#142480",
    fillRule: "nonzero",
    "group-id": 1,
    "node-id": 360,
    stroke: "none",
    "target-height": 376.39996,
    "target-width": 609.5,
    "target-x": 289.9,
    "target-y": 458.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 273.60 832.80 L 786.70 832.80 L 878.60 460.00 L 374.90 460.00 L 273.60 832.80 Z",
    fill: "#94b8ed",
    fillRule: "nonzero",
    "group-id": 1,
    "node-id": 362,
    stroke: "none",
    "target-height": 372.8,
    "target-width": 605,
    "target-x": 273.6,
    "target-y": 460
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 788.10 834.60 L 271.30 834.60 L 373.50 458.20 L 880.90 458.20 Z M 275.90 831.10 L 785.40 831.10 L 876.40 461.80 L 376.20 461.80 Z",
    fill: "#94b8ed",
    fillRule: "nonzero",
    "group-id": 1,
    "node-id": 364,
    stroke: "none",
    "target-height": 376.39996,
    "target-width": 609.60004,
    "target-x": 271.3,
    "target-y": 458.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 311.60 806.80 L 753.10 806.80 L 834.50 486.00 L 398.70 486.00 L 311.60 806.80 Z",
    fill: "#e7f4fa",
    fillRule: "nonzero",
    "group-id": 1,
    "node-id": 366,
    stroke: "none",
    "target-height": 320.8,
    "target-width": 522.9,
    "target-x": 311.6,
    "target-y": 486
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 754.50 808.60 L 309.30 808.60 L 397.40 484.30 L 836.70 484.30 Z M 313.90 805.10 L 751.70 805.10 L 832.20 487.80 L 400.10 487.80 Z",
    fill: "#e7f4fa",
    fillRule: "nonzero",
    "group-id": 1,
    "node-id": 368,
    stroke: "none",
    "target-height": 324.3,
    "target-width": 527.4,
    "target-x": 309.3,
    "target-y": 484.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 797.60 832.90 L 66.30 832.90 L 66.30 790.30 L 807.20 790.30 L 797.60 832.90 Z",
    fill: "#142480",
    fillRule: "nonzero",
    "group-id": 1,
    "node-id": 370,
    stroke: "none",
    "target-height": 42.600037,
    "target-width": 740.9,
    "target-x": 66.3,
    "target-y": 790.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 799.00 834.70 L 64.50 834.70 L 64.50 788.60 L 809.50 788.60 Z M 68.00 831.10 L 796.10 831.10 L 805.00 792.10 L 68.10 792.10 Z",
    fill: "#142480",
    fillRule: "nonzero",
    "group-id": 1,
    "node-id": 372,
    stroke: "none",
    "target-height": 46.100037,
    "target-width": 745,
    "target-x": 64.5,
    "target-y": 788.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 141.80 742.40 L 140.60 742.20 L 139.60 741.50 L 139.00 740.60 L 138.80 739.40 L 138.80 716.30 L 139.00 715.10 L 139.60 714.20 L 140.60 713.50 L 141.80 713.30 L 142.90 713.50 L 143.90 714.20 L 144.50 715.10 L 144.80 716.30 L 144.80 739.40 L 144.50 740.50 L 143.90 741.50 L 142.90 742.20 L 141.80 742.40 Z",
    fill: "#f2b541",
    fillRule: "nonzero",
    "group-id": 1,
    "node-id": 374,
    stroke: "none",
    "target-height": 29.100037,
    "target-width": 6,
    "target-x": 138.8,
    "target-y": 713.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 127.20 727.80 L 127.40 726.70 L 128.10 725.70 L 129.00 725.10 L 130.20 724.80 L 153.30 724.80 L 154.50 725.10 L 155.40 725.70 L 156.00 726.70 L 156.30 727.80 L 156.00 729.00 L 155.40 730.00 L 154.50 730.60 L 153.30 730.80 L 130.20 730.80 L 129.10 730.60 L 128.10 730.00 L 127.40 729.00 L 127.20 727.80 Z",
    fill: "#f2b541",
    fillRule: "nonzero",
    "group-id": 1,
    "node-id": 376,
    stroke: "none",
    "target-height": 6,
    "target-width": 29.100006,
    "target-x": 127.2,
    "target-y": 724.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 706.40 272.00 L 818.30 272.00 L 818.30 326.90 L 706.40 326.90 Z",
    fill: "#75c2d3",
    fillRule: "nonzero",
    "group-id": 1,
    "node-id": 378,
    stroke: "none",
    "target-height": 54.899994,
    "target-width": 111.89996,
    "target-x": 706.4,
    "target-y": 272
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 706.40 272.00 L 762.40 299.50 L 818.30 272.00 L 706.40 272.00 Z",
    fill: "#acdff2",
    fillRule: "nonzero",
    "group-id": 1,
    "node-id": 380,
    stroke: "none",
    "target-height": 27.5,
    "target-width": 111.89996,
    "target-x": 706.4,
    "target-y": 272
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 779.50 394.70 L 813.90 394.70 L 814.30 395.10 L 814.10 401.60 L 779.50 401.80 L 779.10 401.30 L 779.10 395.10 L 779.50 394.70 Z",
    fill: "#5fb7ff",
    fillRule: "nonzero",
    "group-id": 1,
    "node-id": 382,
    stroke: "none",
    "target-height": 7.0999756,
    "target-width": 35.200012,
    "target-x": 779.1,
    "target-y": 394.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 234.80 633.00 L 226.10 626.90 L 218.50 620.30 L 214.80 616.50 L 211.50 612.50 L 208.30 606.80 L 207.30 604.00 L 206.70 600.40 L 206.60 597.40 L 206.90 594.90 L 207.60 592.50 L 209.50 588.90 L 211.30 586.70 L 214.40 584.40 L 242.60 620.70 L 248.20 628.40 L 250.90 633.20 L 251.20 634.50 L 251.10 635.70 L 250.60 636.50 L 249.80 636.90 L 248.10 637.10 L 243.30 636.30 L 234.80 633.00 Z",
    fill: "#ffbe9e",
    fillRule: "nonzero",
    "group-id": 1,
    "node-id": 384,
    stroke: "none",
    "target-height": 52.69995,
    "target-width": 44.59999,
    "target-x": 206.6,
    "target-y": 584.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 201.50 570.10 L 199.40 572.20 L 197.80 574.50 L 196.80 577.10 L 196.30 579.80 L 196.20 582.70 L 196.50 585.80 L 197.50 590.50 L 199.20 595.40 L 203.50 604.60 L 208.30 612.40 L 213.70 620.00 L 234.50 609.20 L 230.90 599.20 L 226.80 589.70 L 221.50 580.00 L 218.40 575.60 L 215.40 572.20 L 213.10 570.20 L 210.80 568.90 L 208.60 568.20 L 206.90 568.00 L 205.20 568.20 L 203.40 568.90 L 201.50 570.10 Z",
    fill: "#e08b03",
    fillRule: "nonzero",
    "group-id": 1,
    "node-id": 386,
    stroke: "none",
    "target-height": 52,
    "target-width": 38.300003,
    "target-x": 196.2,
    "target-y": 568
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 154.70 710.00 L 230.20 656.70 L 228.70 645.80 L 156.90 640.40 L 154.70 710.00 Z",
    fill: "#5a7fe5",
    fillRule: "nonzero",
    "group-id": 1,
    "node-id": 388,
    stroke: "none",
    "target-height": 69.599976,
    "target-width": 75.5,
    "target-x": 154.7,
    "target-y": 640.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 219.90 579.80 L 218.70 577.00 L 217.20 574.60 L 215.40 572.50 L 213.10 570.80 L 209.80 568.80 L 205.90 567.30 L 201.60 566.20 L 197.10 565.50 L 187.30 565.10 L 179.90 565.50 L 168.30 567.10 L 161.40 569.40 L 159.10 570.60 L 155.30 573.90 L 152.50 578.30 L 150.60 584.40 L 150.10 588.50 L 149.90 596.20 L 150.40 607.70 L 151.50 621.30 L 153.10 634.90 L 155.40 646.90 L 156.80 651.90 L 158.20 655.30 L 163.90 657.40 L 169.10 658.60 L 174.90 659.50 L 182.90 659.90 L 188.50 659.90 L 202.80 658.50 L 210.30 657.20 L 219.00 655.20 L 228.80 652.50 L 228.60 636.50 L 228.20 628.90 L 226.40 610.30 L 224.80 600.10 L 222.70 589.90 L 219.90 579.80 Z",
    fill: "#feb801",
    fillRule: "nonzero",
    "group-id": 1,
    "node-id": 390,
    stroke: "none",
    "target-height": 94.80005,
    "target-width": 78.90001,
    "target-x": 149.9,
    "target-y": 565.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 155.30 658.00 L 168.40 659.80 L 174.70 660.40 L 189.90 660.90 L 198.20 660.60 L 206.70 659.80 L 215.00 658.30 L 220.50 657.00 L 225.70 655.20 L 230.70 653.20 L 228.60 645.80 L 220.80 648.10 L 214.50 649.50 L 207.50 650.70 L 192.60 652.20 L 178.80 652.30 L 171.60 651.90 L 164.00 650.90 L 156.00 649.50 Z",
    fill: "#305dde",
    fillRule: "nonzero",
    "group-id": 1,
    "node-id": 392,
    stroke: "none",
    "target-height": 15.100037,
    "target-width": 75.399994,
    "target-x": 155.3,
    "target-y": 645.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 178.40 650.50 L 182.50 650.50 L 183.50 662.90 L 176.70 662.90 L 178.40 650.50 Z",
    fill: "#5a7fe5",
    fillRule: "nonzero",
    "group-id": 1,
    "node-id": 394,
    stroke: "none",
    "target-height": 12.400024,
    "target-width": 6.800003,
    "target-x": 176.7,
    "target-y": 650.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 207.20 649.10 L 210.20 648.20 L 215.30 659.50 L 209.10 661.40 L 207.20 649.10 Z",
    fill: "#5a7fe5",
    fillRule: "nonzero",
    "group-id": 1,
    "node-id": 396,
    stroke: "none",
    "target-height": 13.200012,
    "target-width": 8.100006,
    "target-x": 207.2,
    "target-y": 648.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 174.60 545.70 L 187.10 548.70 L 191.60 550.30 L 193.00 551.00 L 192.90 553.60 L 194.70 562.80 L 197.20 567.20 L 199.80 570.70 L 199.70 572.30 L 198.90 573.40 L 197.60 574.40 L 194.30 575.70 L 189.50 576.30 L 185.40 576.40 L 182.00 576.10 L 178.60 575.20 L 176.30 574.20 L 174.70 573.00 L 173.70 571.80 L 173.40 570.70 L 173.40 569.60 L 176.40 563.00 L 176.90 560.40 L 177.10 556.50 L 176.20 549.90 L 174.60 545.70 Z",
    fill: "#ffbe9e",
    fillRule: "nonzero",
    "group-id": 1,
    "node-id": 398,
    stroke: "none",
    "target-height": 30.700012,
    "target-width": 26.40001,
    "target-x": 173.4,
    "target-y": 545.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 194.00 559.40 L 192.90 553.60 L 193.00 551.00 L 191.50 550.20 L 186.60 548.60 L 173.10 545.30 L 175.60 549.20 L 176.80 553.60 L 178.90 556.10 L 183.30 559.90 L 186.90 562.00 L 190.30 563.70 L 196.40 566.00 L 195.30 563.90 L 194.00 559.40 Z",
    fill: "#ff9c81",
    fillRule: "nonzero",
    "group-id": 1,
    "node-id": 400,
    stroke: "none",
    "target-height": 20.700012,
    "target-width": 23.299988,
    "target-x": 173.1,
    "target-y": 545.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 194.40 523.10 L 196.60 525.10 L 198.70 528.10 L 200.60 531.50 L 202.20 535.40 L 203.40 539.40 L 204.30 546.50 L 203.80 551.80 L 203.10 554.30 L 202.00 556.60 L 200.60 558.60 L 199.30 559.70 L 197.60 560.30 L 195.40 560.60 L 190.50 559.90 L 187.70 559.00 L 182.20 556.20 L 176.80 552.10 L 174.50 549.60 L 171.90 545.80 L 170.90 540.30 L 170.90 536.30 L 171.90 530.70 L 173.10 527.50 L 174.10 526.00 L 176.00 524.20 L 178.40 522.70 L 183.50 520.90 L 187.90 520.60 L 190.10 521.00 L 192.20 521.80 L 194.40 523.10 Z",
    fill: "#ffbe9e",
    fillRule: "nonzero",
    "group-id": 1,
    "node-id": 402,
    stroke: "none",
    "target-height": 40,
    "target-width": 33.40001,
    "target-x": 170.9,
    "target-y": 520.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 203.30 538.90 L 202.20 535.10 L 200.50 531.20 L 199.30 529.30 L 196.70 526.80 L 194.00 525.80 L 192.70 525.90 L 189.60 528.60 L 188.10 529.00 L 182.70 528.10 L 181.30 528.40 L 180.10 529.10 L 179.00 531.10 L 178.70 533.00 L 178.70 536.10 L 179.40 541.80 L 178.30 544.40 L 179.40 548.10 L 179.20 548.30 L 177.10 547.00 L 176.50 546.80 L 176.30 547.00 L 177.80 551.90 L 177.70 552.70 L 176.90 553.60 L 176.10 553.50 L 175.10 552.90 L 173.60 551.50 L 168.40 547.90 L 166.90 546.50 L 165.10 543.80 L 163.80 541.00 L 163.00 537.90 L 162.70 534.70 L 163.00 531.60 L 163.80 528.60 L 165.10 526.40 L 166.70 524.60 L 168.70 523.20 L 170.90 522.10 L 175.20 521.10 L 181.40 518.90 L 182.80 517.80 L 185.40 514.90 L 187.20 513.80 L 189.20 513.10 L 191.40 512.90 L 193.50 513.30 L 195.40 514.30 L 196.90 515.70 L 198.00 517.60 L 199.40 521.00 L 200.30 521.70 L 201.90 522.30 L 202.90 523.60 L 204.00 527.90 L 204.00 530.00 L 203.00 535.70 L 203.30 538.90 Z",
    fill: "#53424d",
    fillRule: "nonzero",
    "group-id": 1,
    "node-id": 404,
    stroke: "none",
    "target-height": 40.69995,
    "target-width": 41.300003,
    "target-x": 162.7,
    "target-y": 512.9
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 181.30 545.70 L 176.70 542.70 L 173.90 541.90 L 172.70 542.20 L 171.70 543.30 L 171.70 544.30 L 172.00 545.80 L 172.90 547.40 L 174.20 548.90 L 177.20 550.70 L 180.20 550.80 L 182.30 550.20 L 183.30 549.70 L 183.80 549.00 L 183.80 548.30 L 182.70 546.90 L 181.30 545.70 Z",
    fill: "#ffbe9e",
    fillRule: "nonzero",
    "group-id": 1,
    "node-id": 406,
    stroke: "none",
    "target-height": 8.899963,
    "target-width": 12.100006,
    "target-x": 171.7,
    "target-y": 541.9
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 228.00 834.30 L 234.30 842.30 L 235.90 844.60 L 237.80 848.30 L 238.10 850.90 L 237.70 852.00 L 236.90 852.90 L 235.50 853.80 L 233.80 854.30 L 232.20 854.30 L 230.50 853.90 L 228.20 852.70 L 224.20 849.10 L 222.10 846.10 L 221.10 845.20 L 216.50 842.50 L 215.70 841.40 L 215.00 838.30 L 215.30 832.50 Z",
    fill: "#53424d",
    fillRule: "nonzero",
    "group-id": 1,
    "node-id": 408,
    stroke: "none",
    "target-height": 21.799988,
    "target-width": 23.100006,
    "target-x": 215,
    "target-y": 832.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 184.20 683.70 L 185.30 685.90 L 187.10 691.20 L 188.80 697.60 L 195.10 726.70 L 204.10 774.50 L 214.40 834.50 L 218.10 836.60 L 220.00 837.00 L 223.00 837.10 L 228.20 836.00 L 231.80 834.50 L 233.00 820.70 L 233.90 806.00 L 234.40 791.10 L 234.70 760.60 L 233.70 717.40 L 232.50 692.40 L 230.00 654.50 L 209.80 668.80 L 190.20 681.80 L 184.50 684.80 L 183.70 685.00 L 183.60 684.70 L 184.20 683.70 Z",
    fill: "#5a7fe5",
    fillRule: "nonzero",
    "group-id": 1,
    "node-id": 410,
    stroke: "none",
    "target-height": 182.59998,
    "target-width": 51.09999,
    "target-x": 183.6,
    "target-y": 654.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 158.50 836.60 L 152.20 844.60 L 150.60 847.00 L 148.70 850.70 L 148.40 853.20 L 148.80 854.30 L 149.60 855.30 L 151.00 856.20 L 152.70 856.60 L 154.30 856.60 L 156.00 856.20 L 158.30 855.00 L 160.50 853.30 L 162.30 851.40 L 164.40 848.40 L 165.40 847.60 L 170.00 844.80 L 170.80 843.80 L 171.50 840.70 L 171.20 834.80 Z",
    fill: "#53424d",
    fillRule: "nonzero",
    "group-id": 1,
    "node-id": 412,
    stroke: "none",
    "target-height": 21.799988,
    "target-width": 23.100006,
    "target-x": 148.4,
    "target-y": 834.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 202.30 686.00 L 201.20 688.10 L 199.40 693.50 L 197.70 699.90 L 191.40 729.00 L 182.40 776.80 L 172.10 836.80 L 168.40 838.90 L 166.50 839.30 L 163.50 839.40 L 160.80 839.00 L 158.30 838.30 L 154.70 836.80 L 153.30 821.00 L 152.40 804.10 L 151.80 787.00 L 151.50 752.50 L 152.70 705.60 L 155.30 658.00 L 176.00 671.80 L 196.00 684.30 L 201.90 687.20 L 202.80 687.30 L 202.90 687.00 L 202.30 686.00 Z",
    fill: "#5a7fe5",
    fillRule: "nonzero",
    "group-id": 1,
    "node-id": 414,
    stroke: "none",
    "target-height": 181.40002,
    "target-width": 51.399994,
    "target-x": 151.5,
    "target-y": 658
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 217.80 605.10 L 258.20 605.10 L 232.90 644.40 L 194.80 644.40 L 217.80 605.10 Z",
    fill: "#253369",
    fillRule: "nonzero",
    "group-id": 1,
    "node-id": 416,
    stroke: "none",
    "target-height": 39.30005,
    "target-width": 63.40001,
    "target-x": 194.8,
    "target-y": 605.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 157.50 640.00 L 153.30 630.30 L 150.30 620.70 L 149.10 615.50 L 148.50 610.40 L 148.70 603.90 L 149.40 601.00 L 150.70 597.70 L 152.20 595.10 L 153.80 593.10 L 155.60 591.40 L 159.20 589.30 L 161.80 588.40 L 165.70 588.00 L 165.40 597.30 L 165.50 606.70 L 166.40 617.20 L 168.30 627.20 L 170.40 633.10 L 172.80 637.70 L 173.40 640.40 L 172.60 642.10 L 169.90 642.80 L 165.30 642.40 L 157.50 640.00 Z",
    fill: "#ffbe9e",
    fillRule: "nonzero",
    "group-id": 1,
    "node-id": 418,
    stroke: "none",
    "target-height": 54.799988,
    "target-width": 24.899994,
    "target-x": 148.5,
    "target-y": 588
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 162.30 569.10 L 159.30 569.70 L 156.80 570.90 L 154.60 572.50 L 152.70 574.60 L 151.10 577.00 L 149.70 579.80 L 148.10 584.30 L 147.00 589.30 L 145.80 599.50 L 145.80 608.70 L 146.40 617.90 L 169.70 619.70 L 171.90 609.20 L 173.40 599.00 L 174.00 588.00 L 173.70 582.70 L 172.90 578.10 L 172.00 575.20 L 170.80 572.90 L 169.30 571.20 L 168.00 570.10 L 166.40 569.40 L 164.50 569.10 L 162.30 569.10 Z",
    fill: "#e08b03",
    fillRule: "nonzero",
    "group-id": 1,
    "node-id": 420,
    stroke: "none",
    "target-height": 50.600037,
    "target-width": 28.199997,
    "target-x": 145.8,
    "target-y": 569.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 162.00 642.90 L 165.70 643.60 L 176.00 644.30 L 192.50 643.80 L 204.00 642.90 L 198.70 635.50 L 160.90 627.80 L 158.00 632.20 L 157.20 634.20 L 156.60 637.60 L 157.50 640.10 L 158.40 641.10 L 159.80 642.10 L 162.00 642.90 Z",
    fill: "#ffbe9e",
    fillRule: "nonzero",
    "group-id": 1,
    "node-id": 422,
    stroke: "none",
    "target-height": 16.5,
    "target-width": 47.399994,
    "target-x": 156.6,
    "target-y": 627.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 197.70 634.30 L 199.30 631.70 L 201.20 629.50 L 206.00 625.10 L 206.60 625.00 L 207.40 625.80 L 207.10 627.40 L 205.50 630.70 L 205.80 632.00 L 206.20 632.60 L 208.00 632.90 L 219.60 631.50 L 220.10 632.20 L 219.80 632.90 L 214.20 634.80 L 214.20 635.20 L 214.60 635.50 L 219.00 635.40 L 220.70 635.80 L 221.00 636.20 L 220.60 636.70 L 215.80 638.10 L 215.80 638.90 L 216.10 639.20 L 218.90 639.80 L 219.20 640.20 L 218.90 640.90 L 218.20 641.20 L 214.40 641.90 L 214.30 642.50 L 215.80 643.20 L 216.10 643.70 L 215.20 644.60 L 212.70 645.10 L 204.80 645.20 L 197.80 644.40 L 194.70 643.60 L 193.30 642.80 L 192.10 641.80 L 190.60 639.10 L 190.30 636.80 L 190.70 635.70 L 190.90 635.40 L 194.60 635.60 L 196.20 635.20 L 197.70 634.30 Z",
    fill: "#ffbe9e",
    fillRule: "nonzero",
    "group-id": 1,
    "node-id": 424,
    stroke: "none",
    "target-height": 20.200012,
    "target-width": 30.699997,
    "target-x": 190.3,
    "target-y": 625
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 245.90 627.00 L 243.70 625.00 L 243.00 624.80 L 241.90 625.20 L 241.80 626.30 L 244.30 630.30 L 244.20 631.60 L 243.80 632.20 L 243.00 632.60 L 230.80 632.90 L 230.10 633.40 L 230.40 634.60 L 236.30 635.50 L 236.30 636.00 L 235.90 636.30 L 231.60 636.80 L 230.00 637.50 L 229.70 637.90 L 230.30 638.40 L 235.10 639.10 L 235.30 639.80 L 235.00 640.20 L 232.40 641.20 L 232.00 641.60 L 232.50 642.30 L 233.30 642.40 L 237.10 642.60 L 237.30 643.20 L 235.90 644.10 L 235.70 644.60 L 236.00 645.10 L 236.70 645.40 L 239.20 645.50 L 244.50 644.70 L 247.10 643.50 L 248.70 642.40 L 250.60 639.90 L 251.10 637.90 L 251.00 635.80 L 250.50 633.70 L 248.60 629.90 L 245.90 627.00 Z",
    fill: "#ffbe9e",
    fillRule: "nonzero",
    "group-id": 1,
    "node-id": 426,
    stroke: "none",
    "target-height": 20.700012,
    "target-width": 21.40001,
    "target-x": 229.7,
    "target-y": 624.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 842.90 194.20 L 817.50 227.30 L 822.90 188.80 L 842.90 194.20 Z",
    fill: "#d6e6f2",
    fillRule: "nonzero",
    "group-id": 1,
    "node-id": 428,
    stroke: "none",
    "target-height": 38.5,
    "target-width": 25.400024,
    "target-x": 817.5,
    "target-y": 188.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 933.00 196.60 L 824.60 196.60 L 821.20 196.30 L 817.90 195.50 L 814.90 194.10 L 812.10 192.40 L 809.70 190.20 L 807.50 187.70 L 805.90 184.90 L 804.60 181.80 L 803.90 178.40 L 799.40 144.90 L 799.20 141.90 L 799.50 139.00 L 800.10 136.10 L 801.20 133.40 L 802.60 130.80 L 804.40 128.40 L 806.60 126.30 L 808.90 124.50 L 811.50 123.10 L 814.30 122.10 L 817.20 121.50 L 820.20 121.20 L 937.50 121.20 L 940.50 121.50 L 943.40 122.10 L 946.10 123.10 L 948.70 124.50 L 951.10 126.30 L 953.20 128.40 L 955.00 130.80 L 956.50 133.40 L 957.50 136.10 L 958.20 139.00 L 958.40 141.90 L 958.20 144.90 L 953.80 178.40 L 953.00 181.80 L 951.80 184.90 L 950.10 187.70 L 948.00 190.30 L 945.50 192.40 L 942.70 194.20 L 939.70 195.50 L 936.50 196.30 L 933.00 196.60 Z",
    fill: "#d6e6f2",
    fillRule: "nonzero",
    "group-id": 1,
    "node-id": 430,
    stroke: "none",
    "target-height": 75.40001,
    "target-width": 159.20001,
    "target-x": 799.2,
    "target-y": 121.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 862.10 158.90 L 861.80 161.00 L 860.90 162.90 L 859.40 164.50 L 857.60 165.60 L 855.50 166.10 L 853.40 166.00 L 851.40 165.30 L 849.70 164.00 L 848.40 162.30 L 847.70 160.30 L 847.60 158.20 L 848.10 156.10 L 849.20 154.30 L 850.80 152.90 L 852.70 152.00 L 854.80 151.60 L 856.80 151.90 L 858.50 152.60 L 859.90 153.80 L 861.10 155.20 L 861.80 156.90 L 862.10 158.90 Z",
    fill: "#f0f8ff",
    fillRule: "nonzero",
    "group-id": 1,
    "node-id": 432,
    stroke: "none",
    "target-height": 14.5,
    "target-width": 14.5,
    "target-x": 847.6,
    "target-y": 151.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 886.10 158.90 L 885.80 161.00 L 884.90 162.90 L 883.50 164.50 L 881.60 165.60 L 879.50 166.10 L 877.40 166.00 L 875.40 165.30 L 873.70 164.00 L 872.40 162.30 L 871.70 160.30 L 871.60 158.20 L 872.10 156.10 L 873.20 154.30 L 874.80 152.90 L 876.70 152.00 L 878.80 151.60 L 880.80 151.90 L 882.50 152.60 L 884.00 153.80 L 885.10 155.20 L 885.80 156.90 L 886.10 158.90 Z",
    fill: "#f0f8ff",
    fillRule: "nonzero",
    "group-id": 1,
    "node-id": 434,
    stroke: "none",
    "target-height": 14.5,
    "target-width": 14.5,
    "target-x": 871.6,
    "target-y": 151.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 910.10 158.90 L 909.80 161.00 L 908.90 162.90 L 907.50 164.50 L 905.60 165.60 L 903.50 166.10 L 901.40 166.00 L 899.50 165.30 L 897.70 164.00 L 896.40 162.30 L 895.70 160.30 L 895.60 158.20 L 896.10 156.10 L 897.20 154.30 L 898.80 152.90 L 900.70 152.00 L 902.80 151.60 L 904.80 151.90 L 906.50 152.60 L 908.00 153.80 L 909.10 155.20 L 909.80 156.90 L 910.10 158.90 Z",
    fill: "#f0f8ff",
    fillRule: "nonzero",
    "group-id": 1,
    "node-id": 436,
    stroke: "none",
    "target-height": 14.5,
    "target-width": 14.5,
    "target-x": 895.6,
    "target-y": 151.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 133.10 432.70 L 152.40 457.90 L 148.30 428.60 L 133.10 432.70 Z",
    fill: "#d6e6f2",
    fillRule: "nonzero",
    "group-id": 1,
    "node-id": 438,
    stroke: "none",
    "target-height": 29.299988,
    "target-width": 19.299988,
    "target-x": 133.1,
    "target-y": 428.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 64.30 434.50 L 147.00 434.50 L 149.60 434.30 L 152.10 433.70 L 156.50 431.30 L 160.00 427.80 L 161.30 425.60 L 162.20 423.20 L 162.80 420.70 L 166.40 392.90 L 166.20 390.60 L 164.90 386.30 L 162.40 382.50 L 159.00 379.60 L 154.90 377.70 L 152.70 377.30 L 60.90 377.10 L 56.40 377.70 L 52.40 379.60 L 48.90 382.50 L 47.50 384.40 L 46.40 386.30 L 45.10 390.60 L 45.10 395.20 L 48.50 420.70 L 49.10 423.20 L 50.00 425.60 L 52.90 429.70 L 56.90 432.70 L 59.20 433.70 L 61.70 434.30 L 64.30 434.50 Z",
    fill: "#d6e6f2",
    fillRule: "nonzero",
    "group-id": 1,
    "node-id": 440,
    stroke: "none",
    "target-height": 57.399994,
    "target-width": 121.299995,
    "target-x": 45.1,
    "target-y": 377.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 118.40 405.80 L 118.60 407.30 L 120.00 409.70 L 122.50 411.10 L 124.00 411.30 L 126.70 410.60 L 128.70 408.60 L 129.30 407.30 L 129.50 405.80 L 128.70 403.00 L 126.70 401.00 L 124.00 400.30 L 122.50 400.50 L 120.00 401.90 L 118.60 404.30 L 118.40 405.80 Z",
    fill: "#f0f8ff",
    fillRule: "nonzero",
    "group-id": 1,
    "node-id": 442,
    stroke: "none",
    "target-height": 11,
    "target-width": 11.099998,
    "target-x": 118.4,
    "target-y": 400.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 100.10 405.80 L 100.40 407.40 L 101.00 408.90 L 102.10 410.10 L 103.50 410.90 L 105.10 411.30 L 106.70 411.20 L 108.20 410.70 L 109.60 409.70 L 110.50 408.40 L 111.10 406.90 L 111.20 405.30 L 110.80 403.70 L 109.90 402.30 L 108.70 401.20 L 107.30 400.50 L 105.70 400.30 L 104.10 400.50 L 101.70 401.90 L 100.30 404.30 L 100.10 405.80 Z",
    fill: "#f0f8ff",
    fillRule: "nonzero",
    "group-id": 1,
    "node-id": 444,
    stroke: "none",
    "target-height": 11,
    "target-width": 11.099998,
    "target-x": 100.1,
    "target-y": 400.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 81.80 405.80 L 82.00 407.30 L 83.40 409.70 L 85.80 411.10 L 87.30 411.30 L 90.10 410.60 L 92.10 408.60 L 92.60 407.30 L 92.90 405.80 L 92.10 403.00 L 90.10 401.00 L 87.30 400.30 L 85.80 400.50 L 83.40 401.90 L 82.00 404.30 L 81.80 405.80 Z",
    fill: "#f0f8ff",
    fillRule: "nonzero",
    "group-id": 1,
    "node-id": 446,
    stroke: "none",
    "target-height": 11,
    "target-width": 11.099998,
    "target-x": 81.8,
    "target-y": 400.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 713.10 895.10 L 695.00 878.00 L 702.90 869.20 L 710.00 860.60 L 716.40 852.00 L 722.00 843.70 L 726.90 835.40 L 731.20 827.20 L 734.90 819.20 L 738.20 810.50 L 740.90 802.00 L 742.90 793.50 L 744.20 785.10 L 745.00 776.70 L 745.10 768.40 L 744.70 760.00 L 742.70 746.60 L 739.40 734.10 L 736.50 726.00 L 733.30 718.40 L 729.80 711.20 L 725.80 704.20 L 717.60 691.60 L 711.10 683.00 L 704.90 675.60 L 693.40 663.80 L 681.70 653.60 L 696.50 633.50 L 705.10 640.70 L 711.00 646.00 L 717.10 652.10 L 724.20 659.80 L 733.80 671.40 L 738.80 678.20 L 743.50 685.20 L 748.10 692.70 L 752.60 700.80 L 756.60 709.20 L 760.30 718.10 L 763.50 727.50 L 765.60 734.60 L 767.30 742.00 L 768.60 749.70 L 769.60 757.70 L 770.10 766.50 L 770.10 775.10 L 769.50 783.80 L 768.40 792.50 L 766.80 801.10 L 764.60 809.80 L 761.90 818.50 L 758.50 827.30 L 754.30 836.70 L 749.40 846.20 L 743.80 855.80 L 737.40 865.40 L 730.20 875.20 L 722.10 885.10 L 713.10 895.10 Z",
    fill: "#c0c7f5",
    fillRule: "nonzero",
    "group-id": 1,
    "node-id": 448,
    stroke: "none",
    "target-height": 261.59998,
    "target-width": 88.39996,
    "target-x": 681.7,
    "target-y": 633.5
  }), /*#__PURE__*/React.createElement("g", {
    "node-id": 558
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 701.10 622.90 L 704.50 624.00 L 707.70 625.40 L 710.60 627.30 L 713.30 629.50 L 715.70 632.00 L 717.80 634.90 L 719.40 638.10 L 720.60 641.40 L 721.40 644.80 L 721.80 648.20 L 721.60 651.70 L 721.10 655.20 L 720.00 658.60 L 718.60 661.80 L 716.70 664.70 L 714.50 667.40 L 711.90 669.80 L 709.00 671.90 L 705.90 673.60 L 702.60 674.80 L 699.20 675.50 L 695.80 675.90 L 692.30 675.80 L 688.80 675.20 L 685.40 674.10 L 682.20 672.70 L 679.20 670.80 L 676.50 668.60 L 674.20 666.10 L 672.10 663.20 L 670.40 660.00 L 669.20 656.80 L 668.40 653.40 L 668.10 649.90 L 668.20 646.40 L 668.80 642.90 L 669.90 639.50 L 671.30 636.30 L 673.20 633.40 L 675.40 630.70 L 677.90 628.30 L 680.80 626.20 L 684.00 624.60 L 687.20 623.30 L 690.60 622.60 L 694.10 622.20 L 697.60 622.30 L 701.10 622.90 Z",
    fill: "#6f66d1",
    fillRule: "nonzero",
    "group-id": "1,16",
    "node-id": 452,
    stroke: "none",
    "target-height": 53.700012,
    "target-width": 53.700012,
    "target-x": 668.1,
    "target-y": 622.2
  })), /*#__PURE__*/React.createElement("path", {
    d: "M 702.00 623.20 L 704.80 626.30 L 707.00 629.50 L 708.60 633.10 L 709.80 636.80 L 710.40 640.60 L 710.40 644.50 L 709.90 648.40 L 708.70 652.20 L 707.00 655.90 L 704.70 659.30 L 702.10 662.20 L 699.10 664.70 L 695.70 666.70 L 692.10 668.20 L 688.40 669.10 L 684.50 669.50 L 680.50 669.40 L 676.50 668.60 L 679.40 670.90 L 682.40 672.80 L 685.70 674.30 L 689.10 675.30 L 692.60 675.80 L 696.20 675.90 L 699.80 675.50 L 703.20 674.60 L 706.70 673.20 L 709.90 671.40 L 712.80 669.20 L 715.30 666.60 L 717.40 663.80 L 719.10 660.70 L 720.50 657.40 L 721.30 653.90 L 721.70 650.30 L 721.70 646.60 L 721.00 642.90 L 720.00 639.50 L 718.50 636.30 L 716.60 633.20 L 714.30 630.50 L 711.70 628.10 L 708.70 626.10 L 705.50 624.50 L 702.00 623.20 Z",
    fill: "#6658c5",
    fillRule: "nonzero",
    "group-id": 1,
    "node-id": 455,
    stroke: "none",
    "target-height": 52.700012,
    "target-width": 45.200012,
    "target-x": 676.5,
    "target-y": 623.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 777.90 759.20 L 777.60 763.00 L 776.70 766.40 L 775.20 769.50 L 773.10 772.40 L 770.70 774.80 L 767.90 776.80 L 764.70 778.30 L 761.30 779.20 L 757.60 779.60 L 753.90 779.20 L 750.50 778.30 L 747.30 776.80 L 744.50 774.80 L 742.10 772.40 L 740.00 769.50 L 738.50 766.40 L 737.60 763.00 L 737.30 759.20 L 737.60 755.50 L 738.50 752.10 L 740.00 749.00 L 742.10 746.10 L 744.50 743.70 L 747.30 741.70 L 750.50 740.20 L 753.90 739.20 L 757.60 738.90 L 761.30 739.20 L 764.70 740.20 L 767.90 741.70 L 770.70 743.70 L 773.10 746.10 L 775.20 749.00 L 776.70 752.10 L 777.60 755.50 L 777.90 759.20 Z",
    fill: "#6f66d1",
    fillRule: "nonzero",
    "group-id": 1,
    "node-id": 457,
    stroke: "none",
    "target-height": 40.69995,
    "target-width": 40.600037,
    "target-x": 737.3,
    "target-y": 738.9
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 763.00 739.60 L 766.40 743.90 L 768.60 748.80 L 769.40 754.00 L 768.80 759.30 L 767.90 762.00 L 765.30 766.70 L 763.50 768.70 L 759.30 772.00 L 754.40 774.00 L 751.80 774.60 L 749.00 774.70 L 743.60 774.00 L 745.80 775.80 L 750.60 778.30 L 753.20 779.10 L 758.50 779.50 L 763.90 778.50 L 766.50 777.50 L 768.90 776.10 L 773.00 772.50 L 774.60 770.30 L 776.90 765.50 L 777.90 760.20 L 777.80 757.40 L 777.40 754.60 L 775.40 749.50 L 774.00 747.20 L 770.30 743.40 L 765.70 740.60 L 763.00 739.60 Z",
    fill: "#6658c5",
    fillRule: "nonzero",
    "group-id": 1,
    "node-id": 459,
    stroke: "none",
    "target-height": 39.900024,
    "target-width": 34.30005,
    "target-x": 743.6,
    "target-y": 739.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 323.00 781.80 L 312.00 781.50 L 300.50 780.50 L 288.60 778.70 L 276.30 776.30 L 263.50 773.00 L 250.10 768.90 L 258.00 745.20 L 269.30 748.70 L 280.10 751.50 L 290.50 753.70 L 300.40 755.30 L 310.00 756.30 L 319.20 756.80 L 328.10 756.70 L 337.30 756.10 L 346.20 754.90 L 354.70 753.20 L 362.90 750.90 L 370.80 748.10 L 378.50 744.70 L 385.90 740.80 L 397.20 733.40 L 407.10 725.10 L 413.30 719.10 L 418.80 713.00 L 423.90 706.80 L 428.60 700.20 L 436.60 687.50 L 441.70 677.90 L 445.70 669.20 L 451.70 653.80 L 456.00 638.90 L 480.40 643.90 L 479.00 649.50 L 475.20 662.30 L 472.20 670.40 L 468.20 680.10 L 461.70 693.70 L 457.70 701.10 L 453.30 708.30 L 448.40 715.60 L 442.90 723.10 L 437.00 730.30 L 430.50 737.30 L 423.30 744.20 L 417.70 749.10 L 411.70 753.70 L 405.20 758.10 L 398.40 762.40 L 390.80 766.40 L 383.10 770.00 L 375.20 773.10 L 367.10 775.70 L 358.80 777.90 L 350.30 779.60 L 341.40 780.80 L 332.40 781.60 L 323.00 781.80 Z",
    fill: "#c0c7f5",
    fillRule: "nonzero",
    "group-id": 1,
    "node-id": 461,
    stroke: "none",
    "target-height": 142.89996,
    "target-width": 230.29999,
    "target-x": 250.1,
    "target-y": 638.9
  }), /*#__PURE__*/React.createElement("g", {
    "node-id": 559
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 481.80 630.10 L 484.10 632.80 L 486.00 635.70 L 487.60 638.80 L 488.70 642.10 L 489.40 645.50 L 489.60 649.10 L 489.40 652.60 L 488.70 656.10 L 487.60 659.40 L 486.00 662.50 L 484.10 665.40 L 481.80 668.10 L 479.10 670.40 L 476.20 672.30 L 473.10 673.90 L 469.70 675.00 L 466.30 675.70 L 462.80 675.90 L 459.20 675.70 L 455.80 675.00 L 452.50 673.90 L 449.40 672.30 L 446.50 670.40 L 443.80 668.10 L 441.50 665.40 L 439.50 662.50 L 438.00 659.40 L 436.90 656.10 L 436.20 652.60 L 435.90 649.10 L 436.20 645.50 L 436.90 642.10 L 438.00 638.80 L 439.50 635.70 L 441.50 632.80 L 443.80 630.10 L 446.50 627.80 L 449.40 625.80 L 452.50 624.30 L 455.80 623.20 L 459.20 622.50 L 462.80 622.30 L 466.30 622.50 L 469.70 623.20 L 473.10 624.30 L 476.20 625.80 L 479.10 627.80 L 481.80 630.10 Z",
    fill: "#6f66d1",
    fillRule: "nonzero",
    "group-id": "1,17",
    "node-id": 465,
    stroke: "none",
    "target-height": 53.600037,
    "target-width": 53.700012,
    "target-x": 435.9,
    "target-y": 622.3
  })), /*#__PURE__*/React.createElement("path", {
    d: "M 469.90 623.20 L 472.60 626.30 L 474.80 629.50 L 476.50 633.10 L 477.60 636.80 L 478.20 640.60 L 478.30 644.50 L 477.70 648.40 L 476.60 652.20 L 474.90 655.90 L 472.60 659.30 L 470.00 662.20 L 466.90 664.70 L 463.60 666.70 L 460.00 668.20 L 456.20 669.10 L 452.30 669.50 L 448.40 669.40 L 444.40 668.60 L 447.20 670.90 L 450.30 672.80 L 453.60 674.30 L 457.00 675.30 L 460.50 675.80 L 464.10 675.90 L 467.60 675.50 L 471.10 674.60 L 474.60 673.20 L 477.80 671.40 L 480.60 669.20 L 483.10 666.60 L 485.30 663.80 L 487.00 660.70 L 488.30 657.40 L 489.20 653.90 L 489.60 650.30 L 489.50 646.60 L 488.90 642.90 L 487.90 639.50 L 486.40 636.30 L 484.40 633.20 L 482.20 630.50 L 479.50 628.10 L 476.60 626.10 L 473.40 624.50 L 469.90 623.20 Z",
    fill: "#6658c5",
    fillRule: "nonzero",
    "group-id": 1,
    "node-id": 468,
    stroke: "none",
    "target-height": 52.700012,
    "target-width": 45.200012,
    "target-x": 444.4,
    "target-y": 623.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 420.90 747.90 L 420.70 750.60 L 419.40 755.70 L 418.20 758.00 L 415.00 762.20 L 410.80 765.40 L 408.40 766.60 L 403.20 768.00 L 400.50 768.20 L 395.30 767.50 L 390.50 765.50 L 388.30 764.00 L 386.20 762.20 L 382.90 758.00 L 381.80 755.60 L 380.40 750.50 L 380.40 745.30 L 380.90 742.70 L 381.80 740.10 L 384.50 735.40 L 388.20 731.70 L 392.80 729.10 L 397.90 727.70 L 400.60 727.50 L 404.30 727.90 L 407.70 728.80 L 410.90 730.30 L 413.70 732.30 L 416.10 734.70 L 418.10 737.60 L 419.60 740.70 L 420.60 744.10 L 420.90 747.90 Z",
    fill: "#6f66d1",
    fillRule: "nonzero",
    "group-id": 1,
    "node-id": 470,
    stroke: "none",
    "target-height": 40.700012,
    "target-width": 40.5,
    "target-x": 380.4,
    "target-y": 727.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 406.00 728.30 L 408.10 730.60 L 409.80 733.00 L 411.00 735.70 L 411.90 738.50 L 412.30 741.40 L 412.40 744.40 L 412.00 747.30 L 411.10 750.20 L 409.80 753.00 L 408.10 755.60 L 406.10 757.80 L 403.80 759.70 L 401.20 761.20 L 398.50 762.30 L 395.70 763.00 L 392.70 763.40 L 389.70 763.20 L 386.70 762.60 L 388.90 764.40 L 393.60 766.90 L 396.20 767.70 L 401.60 768.20 L 406.90 767.20 L 409.50 766.10 L 412.00 764.70 L 416.00 761.10 L 417.70 759.00 L 420.00 754.10 L 420.90 748.80 L 420.90 746.00 L 420.40 743.20 L 418.50 738.10 L 417.00 735.80 L 413.30 732.00 L 408.70 729.20 L 406.00 728.30 Z",
    fill: "#6658c5",
    fillRule: "nonzero",
    "group-id": 1,
    "node-id": 472,
    stroke: "none",
    "target-height": 39.900024,
    "target-width": 34.19998,
    "target-x": 386.7,
    "target-y": 728.3
  }), /*#__PURE__*/React.createElement("g", {
    "node-id": 560
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-path)",
    "group-id": "1,18",
    "node-id": 474
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 521.20 545.60 L 643.30 545.80 L 644.00 546.30 L 644.70 547.90 L 644.70 588.60 L 644.00 590.30 L 643.30 590.70 L 520.30 590.70 L 519.50 590.30 L 518.90 588.60 L 518.90 547.90 L 519.50 546.30 L 521.20 545.60 Z",
    fill: "#6658c5",
    fillRule: "nonzero",
    "group-id": "1,18",
    "node-id": 476,
    stroke: "none",
    "target-height": 45.100037,
    "target-width": 125.79999,
    "target-x": 518.9,
    "target-y": 545.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 519.90 545.60 L 625.50 545.60 L 626.30 545.90 L 626.60 546.60 L 626.60 589.90 L 626.30 590.60 L 625.50 590.90 L 519.90 590.90 L 519.20 590.60 L 518.90 589.90 L 518.90 546.60 L 519.20 545.90 L 519.90 545.60 Z",
    fill: "#6f66d1",
    fillRule: "nonzero",
    "group-id": "1,18",
    "node-id": 478,
    stroke: "none",
    "target-height": 45.30005,
    "target-width": 107.69995,
    "target-x": 518.9,
    "target-y": 545.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 432.80 498.70 L 433.00 501.90 L 433.60 504.90 L 434.60 507.70 L 435.90 510.40 L 439.50 515.00 L 444.20 518.60 L 446.80 520.00 L 449.60 521.00 L 452.60 521.60 L 455.80 521.80 L 462.00 521.00 L 464.80 520.00 L 470.00 517.00 L 474.10 512.80 L 475.80 510.40 L 478.10 504.90 L 478.70 501.90 L 478.90 498.70 L 478.70 495.50 L 478.10 492.50 L 477.10 489.70 L 474.10 484.60 L 470.00 480.50 L 464.80 477.40 L 462.00 476.50 L 459.00 475.90 L 455.80 475.60 L 452.60 475.90 L 446.80 477.40 L 444.20 478.80 L 439.50 482.40 L 435.90 487.10 L 434.60 489.70 L 433.00 495.50 L 432.80 498.70 Z",
    fill: "#6f66d1",
    fillRule: "nonzero",
    "group-id": "1,18",
    "node-id": 480,
    stroke: "none",
    "target-height": 46.19998,
    "target-width": 46.100006,
    "target-x": 432.8,
    "target-y": 475.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 590.90 443.60 L 577.30 443.60 L 575.50 443.30 L 573.60 442.50 L 572.70 441.30 L 575.00 377.90 L 575.70 376.30 L 577.30 375.60 L 590.90 375.60 L 592.50 376.30 L 593.10 377.90 L 595.40 441.30 L 594.50 442.50 L 592.60 443.30 L 590.90 443.60 Z",
    fill: "#6658c5",
    fillRule: "nonzero",
    "group-id": "1,18",
    "node-id": 482,
    stroke: "none",
    "target-height": 68,
    "target-width": 22.700012,
    "target-x": 572.7,
    "target-y": 375.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 543.30 422.10 L 643.00 422.10 L 647.80 422.70 L 652.30 424.60 L 656.20 427.50 L 657.80 429.40 L 659.20 431.40 L 661.10 435.90 L 661.70 440.80 L 661.50 467.00 L 661.10 469.40 L 659.20 473.90 L 656.20 477.80 L 652.30 480.80 L 647.80 482.60 L 645.50 483.10 L 543.30 483.30 L 538.40 482.60 L 533.90 480.80 L 530.00 477.80 L 528.40 475.90 L 527.00 473.90 L 525.20 469.40 L 524.60 464.60 L 524.70 438.30 L 525.20 435.90 L 527.00 431.40 L 530.00 427.50 L 531.90 425.90 L 536.10 423.50 L 540.80 422.20 L 543.30 422.10 Z",
    fill: "#6658c5",
    fillRule: "nonzero",
    "group-id": "1,18",
    "node-id": 484,
    stroke: "none",
    "target-height": 61.19998,
    "target-width": 137.10004,
    "target-x": 524.6,
    "target-y": 422.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 520.10 422.10 L 639.00 422.10 L 642.50 422.80 L 645.40 424.70 L 646.60 426.10 L 647.90 429.40 L 648.10 474.10 L 647.90 475.90 L 646.60 479.20 L 644.00 481.70 L 640.80 483.10 L 520.10 483.30 L 516.60 482.60 L 513.60 480.60 L 512.50 479.20 L 511.10 475.90 L 511.00 431.20 L 511.60 427.70 L 513.60 424.70 L 516.60 422.80 L 520.10 422.10 Z",
    fill: "#6f66d1",
    fillRule: "nonzero",
    "group-id": "1,18",
    "node-id": 486,
    stroke: "none",
    "target-height": 61.19998,
    "target-width": 137.09998,
    "target-x": 511,
    "target-y": 422.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 518.90 443.60 L 681.00 443.60 L 685.30 443.90 L 689.40 444.70 L 693.30 446.10 L 697.00 447.90 L 700.30 450.20 L 703.40 452.90 L 706.10 455.90 L 708.30 459.30 L 710.20 463.00 L 711.60 466.90 L 712.40 471.00 L 712.70 475.30 L 712.70 526.30 L 712.40 530.70 L 711.60 534.80 L 710.20 538.70 L 708.30 542.40 L 706.10 545.70 L 703.40 548.80 L 700.30 551.50 L 697.00 553.70 L 693.30 555.60 L 689.40 556.90 L 685.30 557.80 L 681.00 558.10 L 518.90 558.10 L 514.50 557.80 L 510.40 556.90 L 506.50 555.60 L 502.80 553.70 L 499.50 551.50 L 496.40 548.80 L 493.80 545.70 L 491.50 542.40 L 489.60 538.70 L 488.30 534.80 L 487.50 530.70 L 487.10 526.30 L 487.10 475.30 L 487.40 471.10 L 488.20 467.10 L 489.60 463.20 L 491.40 459.50 L 493.70 456.00 L 496.40 452.90 L 499.60 450.10 L 503.00 447.80 L 506.70 446.00 L 510.60 444.70 L 514.70 443.90 L 518.90 443.60 Z",
    fill: "#c0c7f5",
    fillRule: "nonzero",
    "group-id": "1,18",
    "node-id": 488,
    stroke: "none",
    "target-height": 114.49997,
    "target-width": 225.6,
    "target-x": 487.1,
    "target-y": 443.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 493.90 443.60 L 656.00 443.60 L 660.40 443.90 L 664.50 444.70 L 668.40 446.10 L 672.10 447.90 L 675.40 450.20 L 678.50 452.90 L 681.10 455.90 L 683.40 459.30 L 685.30 463.00 L 686.60 466.90 L 687.40 471.00 L 687.80 475.30 L 687.80 526.30 L 687.40 530.70 L 686.60 534.80 L 685.30 538.70 L 683.40 542.40 L 681.10 545.70 L 678.50 548.80 L 675.40 551.50 L 672.10 553.70 L 668.40 555.60 L 664.50 556.90 L 660.40 557.80 L 656.00 558.10 L 493.90 558.10 L 489.60 557.80 L 485.50 556.90 L 481.60 555.60 L 477.90 553.70 L 474.60 551.50 L 471.50 548.80 L 468.80 545.70 L 466.60 542.40 L 464.70 538.70 L 463.30 534.80 L 462.50 530.70 L 462.20 526.30 L 462.20 475.30 L 462.50 471.10 L 463.30 467.10 L 464.60 463.20 L 466.40 459.50 L 468.70 456.00 L 471.50 452.90 L 474.70 450.10 L 478.10 447.80 L 481.80 446.00 L 485.70 444.70 L 489.70 443.90 L 493.90 443.60 Z",
    fill: "#d1d5fc",
    fillRule: "nonzero",
    "group-id": "1,18",
    "node-id": 490,
    stroke: "none",
    "target-height": 114.49997,
    "target-width": 225.59998,
    "target-x": 462.2,
    "target-y": 443.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 503.60 468.50 L 650.90 468.50 L 653.90 468.80 L 656.70 469.60 L 659.20 470.80 L 661.50 472.40 L 663.50 474.40 L 665.10 476.70 L 666.30 479.20 L 667.10 482.00 L 667.40 485.00 L 667.40 513.30 L 667.10 516.30 L 666.30 519.00 L 665.10 521.60 L 663.50 523.90 L 661.50 525.90 L 659.20 527.50 L 656.70 528.70 L 653.90 529.50 L 650.90 529.70 L 503.60 529.70 L 500.60 529.50 L 497.80 528.70 L 495.30 527.50 L 493.00 525.90 L 491.00 523.90 L 489.40 521.60 L 488.20 519.00 L 487.40 516.30 L 487.10 513.30 L 487.10 485.00 L 487.40 482.00 L 488.20 479.20 L 489.40 476.70 L 491.00 474.40 L 493.00 472.40 L 495.30 470.80 L 497.80 469.60 L 500.60 468.80 L 503.60 468.50 Z",
    fill: "#5250ba",
    fillRule: "nonzero",
    "group-id": "1,18",
    "node-id": 492,
    stroke: "none",
    "target-height": 61.200012,
    "target-width": 180.30002,
    "target-x": 487.1,
    "target-y": 468.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 502.60 475.60 L 651.90 475.60 L 654.90 475.90 L 657.80 476.80 L 660.50 478.20 L 662.80 480.10 L 664.80 482.50 L 666.20 485.10 L 667.10 488.00 L 667.40 491.10 L 667.40 514.30 L 667.10 517.30 L 666.20 520.20 L 664.80 522.80 L 662.80 525.20 L 660.50 527.10 L 657.80 528.60 L 654.90 529.40 L 651.90 529.70 L 502.60 529.70 L 499.60 529.40 L 496.70 528.60 L 494.00 527.10 L 491.70 525.20 L 489.70 522.80 L 488.30 520.20 L 487.50 517.30 L 487.10 514.30 L 487.10 491.10 L 487.50 488.00 L 488.30 485.10 L 489.70 482.50 L 491.70 480.10 L 494.00 478.20 L 496.70 476.80 L 499.60 475.90 L 502.60 475.60 Z",
    fill: "#6f66d1",
    fillRule: "nonzero",
    "group-id": "1,18",
    "node-id": 494,
    stroke: "none",
    "target-height": 54.100006,
    "target-width": 180.30002,
    "target-x": 487.1,
    "target-y": 475.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 532.50 491.20 L 532.20 493.30 L 531.40 495.20 L 530.20 496.80 L 528.60 498.00 L 526.70 498.80 L 524.60 499.10 L 522.40 498.80 L 520.50 498.00 L 518.90 496.80 L 517.70 495.20 L 516.90 493.30 L 516.60 491.20 L 516.90 489.10 L 517.70 487.20 L 518.90 485.60 L 520.50 484.30 L 522.40 483.50 L 524.60 483.30 L 526.70 483.50 L 528.60 484.30 L 530.20 485.60 L 531.40 487.20 L 532.20 489.10 L 532.50 491.20 Z",
    fill: "#ffffff",
    fillRule: "nonzero",
    "group-id": "1,18",
    "node-id": 496,
    stroke: "none",
    "target-height": 15.800018,
    "target-width": 15.900024,
    "target-x": 516.6,
    "target-y": 483.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 632.20 491.20 L 631.60 494.20 L 629.90 496.80 L 627.30 498.50 L 625.80 499.00 L 622.70 499.00 L 619.90 497.80 L 617.70 495.60 L 616.50 492.70 L 616.50 489.70 L 617.70 486.70 L 618.70 485.60 L 621.20 483.90 L 624.30 483.30 L 626.40 483.50 L 628.30 484.30 L 629.90 485.60 L 631.10 487.20 L 631.90 489.10 L 632.20 491.20 Z",
    fill: "#ffffff",
    fillRule: "nonzero",
    "group-id": "1,18",
    "node-id": 498,
    stroke: "none",
    "target-height": 15.700012,
    "target-width": 15.700012,
    "target-x": 616.5,
    "target-y": 483.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 746.40 498.70 L 746.10 501.90 L 744.60 507.70 L 743.20 510.40 L 739.60 515.00 L 734.90 518.60 L 732.30 520.00 L 726.50 521.60 L 723.30 521.80 L 717.10 521.00 L 714.30 520.00 L 709.20 517.00 L 705.00 512.80 L 703.40 510.40 L 701.10 504.90 L 700.50 501.90 L 700.20 498.70 L 700.50 495.50 L 701.10 492.50 L 702.00 489.70 L 705.00 484.60 L 709.20 480.50 L 714.30 477.40 L 720.10 475.90 L 723.30 475.60 L 726.50 475.90 L 732.30 477.40 L 734.90 478.80 L 739.60 482.40 L 743.20 487.10 L 744.60 489.70 L 746.10 495.50 L 746.40 498.70 Z",
    fill: "#6658c5",
    fillRule: "nonzero",
    "group-id": "1,18",
    "node-id": 500,
    stroke: "none",
    "target-height": 46.19998,
    "target-width": 46.200012,
    "target-x": 700.2,
    "target-y": 475.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 737.30 498.70 L 737.10 501.90 L 735.50 507.70 L 734.20 510.40 L 730.60 515.00 L 725.90 518.60 L 723.20 520.00 L 720.40 521.00 L 717.40 521.60 L 714.20 521.80 L 711.00 521.60 L 708.10 521.00 L 705.20 520.00 L 700.10 517.00 L 696.00 512.80 L 694.30 510.40 L 693.00 507.70 L 692.00 504.90 L 691.40 501.90 L 691.20 498.70 L 691.40 495.50 L 692.00 492.50 L 693.00 489.70 L 696.00 484.60 L 700.10 480.50 L 705.20 477.40 L 708.10 476.50 L 711.00 475.90 L 714.20 475.60 L 717.40 475.90 L 723.20 477.50 L 725.90 478.80 L 730.60 482.40 L 734.20 487.10 L 735.50 489.70 L 736.50 492.50 L 737.10 495.50 L 737.30 498.70 Z",
    fill: "#6f66d1",
    fillRule: "nonzero",
    "group-id": "1,18",
    "node-id": 502,
    stroke: "none",
    "target-height": 46.19998,
    "target-width": 46.099976,
    "target-x": 691.2,
    "target-y": 475.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 592.60 500.80 L 557.40 500.80 L 557.60 504.00 L 558.40 507.00 L 559.60 509.80 L 561.40 512.30 L 563.50 514.50 L 566.10 516.40 L 569.00 517.80 L 571.90 518.60 L 575.00 518.80 L 578.10 518.60 L 581.00 517.80 L 583.90 516.40 L 586.50 514.50 L 588.60 512.30 L 590.30 509.80 L 591.60 507.00 L 592.30 504.00 L 592.60 500.80 Z",
    fill: "#ffffff",
    fillRule: "nonzero",
    "group-id": "1,18",
    "node-id": 504,
    stroke: "none",
    "target-height": 18,
    "target-width": 35.19995,
    "target-x": 557.4,
    "target-y": 500.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 608.70 867.50 L 551.30 867.50 L 544.00 867.20 L 536.90 866.30 L 530.00 864.90 L 523.40 863.00 L 516.80 860.50 L 510.60 857.60 L 504.70 854.20 L 499.10 850.40 L 493.70 846.10 L 488.80 841.50 L 484.20 836.60 L 479.90 831.20 L 476.10 825.60 L 472.70 819.70 L 469.80 813.50 L 467.40 806.90 L 465.40 800.30 L 464.00 793.40 L 463.10 786.30 L 462.80 779.00 L 462.80 687.30 L 463.10 679.10 L 463.90 671.10 L 465.20 663.30 L 467.00 655.70 L 469.40 648.20 L 472.20 641.00 L 475.40 634.10 L 479.10 627.30 L 483.20 620.80 L 487.70 614.70 L 492.50 608.80 L 497.70 603.20 L 503.30 598.00 L 509.20 593.10 L 515.30 588.70 L 521.80 584.60 L 528.60 580.90 L 535.50 577.70 L 542.80 574.90 L 550.20 572.50 L 557.80 570.70 L 565.60 569.40 L 573.60 568.50 L 581.80 568.30 L 590.00 568.50 L 598.00 569.40 L 605.70 570.70 L 613.30 572.50 L 620.80 574.90 L 628.00 577.70 L 635.00 580.90 L 641.70 584.60 L 648.20 588.70 L 654.40 593.10 L 660.30 598.00 L 665.80 603.20 L 671.10 608.80 L 675.90 614.70 L 680.40 620.80 L 684.50 627.30 L 688.10 634.10 L 691.40 641.00 L 694.20 648.20 L 696.50 655.70 L 698.30 663.30 L 699.70 671.10 L 700.50 679.10 L 700.80 687.30 L 700.80 775.40 L 700.50 783.00 L 699.60 790.40 L 698.10 797.50 L 696.10 804.50 L 693.50 811.20 L 690.50 817.70 L 686.90 823.80 L 683.00 829.70 L 678.50 835.30 L 673.70 840.50 L 668.60 845.30 L 663.00 849.70 L 657.10 853.70 L 650.90 857.20 L 644.50 860.20 L 637.70 862.80 L 630.80 864.80 L 623.60 866.30 L 616.30 867.20 L 608.70 867.50 Z",
    fill: "#d1d5fc",
    fillRule: "nonzero",
    "group-id": "1,18",
    "node-id": 506,
    stroke: "none",
    "target-height": 299.2,
    "target-width": 238,
    "target-x": 462.8,
    "target-y": 568.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 559.40 618.10 L 599.60 618.10 L 605.10 618.40 L 610.50 619.00 L 615.70 620.10 L 620.70 621.50 L 625.70 623.40 L 630.40 625.60 L 634.80 628.10 L 643.20 634.20 L 650.40 641.50 L 653.60 645.50 L 656.50 649.80 L 659.00 654.30 L 661.20 659.00 L 663.10 663.90 L 664.60 668.90 L 665.60 674.10 L 666.30 679.50 L 666.50 685.10 L 666.50 770.00 L 666.30 775.50 L 665.60 780.90 L 664.60 786.10 L 663.10 791.10 L 661.20 796.10 L 659.00 800.80 L 653.60 809.50 L 646.90 817.30 L 639.10 824.00 L 634.80 826.90 L 630.40 829.40 L 625.70 831.60 L 620.70 833.50 L 615.70 835.00 L 610.50 836.00 L 605.10 836.70 L 599.60 836.90 L 559.40 836.90 L 553.90 836.70 L 548.50 836.00 L 543.30 835.00 L 538.30 833.50 L 533.40 831.60 L 528.70 829.40 L 524.20 826.90 L 519.90 824.00 L 515.90 820.80 L 508.60 813.60 L 502.50 805.20 L 500.00 800.80 L 497.80 796.10 L 495.90 791.10 L 494.50 786.10 L 493.40 780.90 L 492.70 775.50 L 492.50 770.00 L 492.50 685.10 L 492.70 679.50 L 493.40 674.10 L 494.50 668.90 L 495.90 663.90 L 497.80 659.00 L 500.00 654.30 L 502.50 649.80 L 508.60 641.50 L 515.90 634.20 L 524.20 628.10 L 528.70 625.60 L 533.40 623.40 L 538.30 621.50 L 543.30 620.10 L 548.50 619.00 L 553.90 618.40 L 559.40 618.10 Z",
    fill: "#6f66d1",
    fillRule: "nonzero",
    "group-id": "1,18",
    "node-id": 508,
    stroke: "none",
    "target-height": 218.80005,
    "target-width": 174,
    "target-x": 492.5,
    "target-y": 618.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 604.70 621.10 L 604.40 624.80 L 603.70 628.40 L 602.50 631.80 L 600.90 635.10 L 598.90 638.10 L 596.50 640.90 L 593.70 643.40 L 590.70 645.40 L 587.40 647.00 L 583.90 648.10 L 580.40 648.90 L 576.70 649.10 L 573.00 648.90 L 569.40 648.10 L 566.00 647.00 L 562.70 645.40 L 559.70 643.40 L 556.90 640.90 L 554.50 638.10 L 552.50 635.10 L 550.90 631.80 L 549.70 628.40 L 549.00 624.80 L 548.70 621.10 L 549.00 617.40 L 549.70 613.90 L 550.90 610.40 L 552.50 607.20 L 554.50 604.20 L 556.90 601.40 L 559.70 598.90 L 562.70 596.90 L 566.00 595.30 L 569.40 594.10 L 573.00 593.40 L 576.70 593.20 L 580.40 593.40 L 583.90 594.10 L 587.40 595.30 L 590.70 596.90 L 593.70 598.90 L 596.50 601.40 L 598.90 604.20 L 600.90 607.20 L 602.50 610.40 L 603.70 613.90 L 604.40 617.40 L 604.70 621.10 Z",
    fill: "#ffffff",
    fillRule: "nonzero",
    "group-id": "1,18",
    "node-id": 510,
    stroke: "none",
    "target-height": 55.899963,
    "target-width": 56,
    "target-x": 548.7,
    "target-y": 593.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 597.30 621.10 L 597.10 623.90 L 595.70 629.10 L 594.50 631.50 L 591.30 635.70 L 587.00 638.90 L 584.60 640.20 L 579.30 641.60 L 576.60 641.70 L 571.40 641.00 L 566.40 639.00 L 564.20 637.50 L 562.10 635.70 L 558.80 631.40 L 557.60 629.00 L 556.30 623.90 L 556.30 618.50 L 556.80 615.90 L 557.70 613.30 L 560.40 608.60 L 564.20 604.80 L 568.80 602.10 L 573.90 600.70 L 576.70 600.60 L 580.40 600.90 L 583.90 601.80 L 587.10 603.40 L 590.00 605.40 L 592.40 607.90 L 594.50 610.80 L 596.00 613.90 L 596.90 617.40 L 597.30 621.10 Z",
    fill: "#d1d5fc",
    fillRule: "nonzero",
    "group-id": "1,18",
    "node-id": 512,
    stroke: "none",
    "target-height": 41.100037,
    "target-width": 41,
    "target-x": 556.3,
    "target-y": 600.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 565.40 669.70 L 565.10 671.50 L 564.30 673.20 L 563.10 674.50 L 561.50 675.50 L 559.70 675.90 L 557.90 675.80 L 556.20 675.20 L 554.70 674.10 L 553.60 672.60 L 553.00 670.90 L 552.90 669.10 L 553.40 667.30 L 554.30 665.70 L 555.70 664.50 L 557.30 663.70 L 559.10 663.50 L 560.80 663.70 L 562.30 664.30 L 563.50 665.30 L 564.50 666.60 L 565.10 668.00 L 565.40 669.70 Z",
    fill: "#d1d5fc",
    fillRule: "nonzero",
    "group-id": "1,18",
    "node-id": 514,
    stroke: "none",
    "target-height": 12.400024,
    "target-width": 12.5,
    "target-x": 552.9,
    "target-y": 663.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 585.80 669.70 L 585.50 671.50 L 584.70 673.20 L 583.50 674.50 L 581.90 675.50 L 580.10 675.90 L 578.30 675.80 L 576.60 675.20 L 575.10 674.10 L 574.00 672.60 L 573.40 670.90 L 573.30 669.10 L 573.80 667.30 L 574.70 665.70 L 576.10 664.50 L 577.70 663.70 L 579.50 663.50 L 581.20 663.70 L 583.90 665.30 L 584.90 666.60 L 585.50 668.00 L 585.80 669.70 Z",
    fill: "#f2b622",
    fillRule: "nonzero",
    "group-id": "1,18",
    "node-id": 516,
    stroke: "none",
    "target-height": 12.400024,
    "target-width": 12.5,
    "target-x": 573.3,
    "target-y": 663.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 606.20 669.70 L 605.90 671.40 L 605.30 672.80 L 604.30 674.10 L 603.10 675.10 L 601.60 675.70 L 599.90 675.90 L 598.20 675.70 L 596.80 675.10 L 595.50 674.10 L 594.50 672.80 L 593.90 671.40 L 593.70 669.70 L 593.90 668.00 L 594.50 666.60 L 595.50 665.30 L 596.80 664.30 L 598.20 663.70 L 599.90 663.50 L 601.60 663.70 L 603.10 664.30 L 604.30 665.30 L 605.30 666.60 L 605.90 668.00 L 606.20 669.70 Z",
    fill: "#6658c5",
    fillRule: "nonzero",
    "group-id": "1,18",
    "node-id": 518,
    stroke: "none",
    "target-height": 12.400024,
    "target-width": 12.5,
    "target-x": 593.7,
    "target-y": 663.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 608.70 867.50 L 616.30 867.20 L 623.60 866.30 L 630.80 864.80 L 637.70 862.80 L 644.50 860.20 L 650.90 857.20 L 657.10 853.70 L 663.00 849.70 L 668.60 845.30 L 673.70 840.50 L 678.50 835.30 L 683.00 829.70 L 686.90 823.80 L 690.50 817.70 L 693.50 811.20 L 696.10 804.50 L 698.10 797.50 L 699.60 790.40 L 700.50 783.00 L 700.80 775.40 L 700.80 687.30 L 700.60 680.20 L 691.90 705.30 L 687.10 717.70 L 681.90 730.00 L 676.20 742.00 L 670.00 753.60 L 665.10 762.20 L 659.80 770.40 L 654.10 778.40 L 648.20 786.10 L 641.90 793.40 L 635.20 800.40 L 628.00 806.90 L 620.50 813.10 L 614.20 817.70 L 607.60 821.90 L 600.70 825.90 L 593.40 829.50 L 585.70 832.90 L 578.00 835.70 L 569.90 838.20 L 561.30 840.40 L 552.30 842.10 L 542.70 843.50 L 533.40 844.30 L 523.50 844.70 L 513.10 844.70 L 502.10 844.10 L 490.40 843.00 L 496.00 848.00 L 502.10 852.50 L 508.40 856.40 L 515.10 859.70 L 521.90 862.50 L 529.10 864.70 L 536.40 866.30 L 543.80 867.20 L 551.40 867.50 Z",
    fill: "#000000",
    fillOpacity: 0.15,
    fillRule: "nonzero",
    "group-id": "1,18,19",
    "node-id": 522,
    stroke: "none",
    "target-height": 187.29999,
    "target-width": 210.4,
    "target-x": 490.4,
    "target-y": 680.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 605.40 371.40 L 605.20 374.30 L 603.80 379.50 L 602.50 382.00 L 599.20 386.30 L 594.90 389.70 L 592.30 390.90 L 589.60 391.90 L 584.20 392.60 L 581.50 392.40 L 576.20 391.00 L 571.50 388.20 L 569.30 386.40 L 567.40 384.20 L 564.70 379.50 L 563.80 376.90 L 563.10 371.50 L 563.80 366.00 L 564.70 363.30 L 566.00 360.80 L 569.30 356.40 L 571.40 354.60 L 576.10 351.90 L 581.40 350.50 L 584.30 350.30 L 587.00 350.50 L 592.30 351.90 L 597.10 354.60 L 599.20 356.50 L 601.00 358.60 L 603.80 363.30 L 605.20 368.60 L 605.40 371.40 Z",
    fill: "#f2b622",
    fillRule: "nonzero",
    "group-id": "1,18",
    "node-id": 525,
    stroke: "none",
    "target-height": 42.30002,
    "target-width": 42.30005,
    "target-x": 563.1,
    "target-y": 350.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 589.80 351.10 L 592.00 353.40 L 593.70 356.00 L 595.10 358.80 L 596.00 361.70 L 596.40 364.70 L 596.50 367.80 L 596.00 370.90 L 595.20 373.90 L 593.80 376.80 L 592.00 379.50 L 589.90 381.80 L 587.50 383.70 L 584.90 385.30 L 582.10 386.50 L 579.10 387.20 L 576.00 387.50 L 572.90 387.40 L 569.80 386.80 L 572.00 388.60 L 577.00 391.30 L 582.40 392.50 L 585.30 392.50 L 590.80 391.50 L 593.50 390.40 L 596.10 389.00 L 600.30 385.20 L 602.00 383.00 L 604.40 377.90 L 605.40 372.40 L 605.30 369.50 L 604.80 366.60 L 602.80 361.30 L 601.30 358.90 L 597.40 354.90 L 592.60 352.00 L 589.80 351.10 Z",
    fill: "#e3ab1f",
    fillRule: "nonzero",
    "group-id": "1,18",
    "node-id": 527,
    stroke: "none",
    "target-height": 41.399994,
    "target-width": 35.600037,
    "target-x": 569.8,
    "target-y": 351.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 650.90 529.70 L 653.90 529.40 L 656.70 528.70 L 659.20 527.50 L 661.50 525.80 L 663.50 523.90 L 665.10 521.60 L 666.30 519.00 L 667.10 516.30 L 667.40 513.30 L 667.40 485.00 L 667.10 482.00 L 666.30 479.30 L 665.10 476.80 L 663.60 474.50 L 661.60 472.60 L 659.40 470.90 L 656.90 469.70 L 654.20 468.90 L 651.30 468.60 L 650.00 473.90 L 648.20 479.10 L 646.00 484.30 L 641.50 491.60 L 638.60 495.20 L 635.30 498.70 L 631.70 501.80 L 627.50 504.90 L 622.60 507.90 L 616.90 510.90 L 611.20 513.40 L 604.70 515.70 L 597.20 518.00 L 588.70 520.10 L 571.00 523.30 L 560.30 524.60 L 548.40 525.60 L 532.70 526.50 L 514.60 526.80 L 493.90 526.60 L 496.10 528.00 L 498.50 529.00 L 501.00 529.60 L 503.60 529.80 Z",
    fill: "#000000",
    fillOpacity: 0.15,
    fillRule: "nonzero",
    "group-id": "1,18,20",
    "node-id": 531,
    stroke: "none",
    "target-height": 61.19998,
    "target-width": 173.50003,
    "target-x": 493.9,
    "target-y": 468.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 475.50 463.60 L 479.60 463.90 L 480.60 464.50 L 481.20 465.50 L 481.50 466.70 L 481.50 532.30 L 481.20 533.50 L 480.60 534.50 L 479.60 535.20 L 478.40 535.40 L 474.30 535.20 L 473.30 534.50 L 472.60 533.50 L 472.40 532.30 L 472.40 466.70 L 472.70 465.50 L 473.30 464.50 L 474.30 463.90 L 475.50 463.60 Z",
    fill: "#e2e7fd",
    fillRule: "nonzero",
    "group-id": "1,18",
    "node-id": 534,
    stroke: "none",
    "target-height": 71.80002,
    "target-width": 9.100006,
    "target-x": 472.4,
    "target-y": 463.6
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M 747.00 850.20 L 746.20 858.40 L 743.80 865.90 L 740.10 872.70 L 735.20 878.70 L 729.30 883.60 L 722.40 887.30 L 718.80 888.60 L 714.90 889.60 L 711.00 890.20 L 706.80 890.50 L 698.60 889.60 L 694.80 888.70 L 691.10 887.30 L 684.30 883.60 L 678.30 878.70 L 673.40 872.70 L 669.70 865.90 L 667.40 858.40 L 666.80 854.40 L 666.50 850.30 L 666.80 846.10 L 667.40 842.10 L 668.30 838.30 L 669.70 834.60 L 673.40 827.70 L 678.30 821.80 L 684.20 816.90 L 691.10 813.20 L 694.80 811.80 L 698.60 810.80 L 706.70 810.00 L 714.60 810.80 L 722.10 813.10 L 729.10 816.70 L 735.20 821.80 L 740.20 827.90 L 743.90 834.80 L 746.20 842.30 L 747.00 850.20 Z",
    fill: "#fec000",
    fillRule: "nonzero",
    "group-id": 1,
    "node-id": 537,
    stroke: "none",
    "target-height": 80.5,
    "target-width": 80.5,
    "target-x": 666.5,
    "target-y": 810
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 667.80 861.30 L 706.70 929.00 L 744.70 862.90 L 667.80 861.30 Z",
    fill: "#fec000",
    fillRule: "nonzero",
    "group-id": 1,
    "node-id": 539,
    stroke: "none",
    "target-height": 67.70001,
    "target-width": 76.900024,
    "target-x": 667.8,
    "target-y": 861.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 725.70 850.60 L 725.50 853.20 L 724.20 858.10 L 721.70 862.40 L 720.00 864.30 L 716.00 867.40 L 713.70 868.60 L 708.70 869.90 L 706.20 870.00 L 701.30 869.40 L 696.60 867.50 L 694.50 866.10 L 692.60 864.40 L 689.40 860.30 L 688.30 858.00 L 687.00 853.20 L 687.00 848.20 L 687.50 845.70 L 688.40 843.20 L 690.90 838.80 L 694.50 835.20 L 698.80 832.70 L 703.70 831.40 L 706.30 831.30 L 709.80 831.60 L 713.10 832.50 L 716.10 833.90 L 718.80 835.80 L 721.10 838.10 L 723.00 840.90 L 724.40 843.90 L 725.30 847.10 L 725.70 850.60 Z",
    fill: "#ffffff",
    fillRule: "nonzero",
    "group-id": 1,
    "node-id": 541,
    stroke: "none",
    "target-height": 38.700012,
    "target-width": 38.700012,
    "target-x": 687,
    "target-y": 831.3
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcAll8);
export default __webpack_public_path__ + "static/media/ic_all_8.2ae13239b74fa87640f5b57801e1a7c9.svg";
export { ForwardRef as ReactComponent };